var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _defs, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g2, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _rect, _circle, _circle2, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _circle3, _circle4, _circle5, _rect2, _path157, _circle6, _rect3, _g3, _g4, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _g5, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _line, _line2, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _circle7, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _g6, _circle8, _path300, _defs2, _path301, _path302;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "error"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 11C9.95 11 9.5 10.55 9.5 10V6C9.5 5.45 9.95 5 10.5 5C11.05 5 11.5 5.45 11.5 6V10C11.5 10.55 11.05 11 10.5 11ZM11.5 15H9.5V13H11.5V15Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "new-folder"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 7.99998H15.9998L13.3332 5.33331H5.33317C3.85317 5.33331 2.67984 6.51998 2.67984 7.99998L2.6665 24C2.6665 25.48 3.85317 26.6666 5.33317 26.6666H26.6665C28.1465 26.6666 29.3332 25.48 29.3332 24V10.6666C29.3332 9.18665 28.1465 7.99998 26.6665 7.99998ZM26.6665 24H5.33317V7.99998H12.2265L14.8932 10.6666H26.6665V24ZM15.9998 18.6666H18.6665V21.3333H21.3332V18.6666H23.9998V16H21.3332V13.3333H18.6665V16H15.9998V18.6666Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "filters"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C15.1046 8 16 7.10457 16 6C16 4.89543 15.1046 4 14 4C12.8954 4 12 4.89543 12 6C12 7.10457 12.8954 8 14 8Z",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14Z",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18H20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "search"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "close"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L4 12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4L12 12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-up"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15L12 9L6 15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9L12 15L18 9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-left"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12L6 8L10 4",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L10 8L6 4",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "users"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "unblock"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M240-640h360v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85h-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640Zm0 480h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM240-160v-400 400Z",
    fill: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "page"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 1.3335H3.99984C3.64622 1.3335 3.30708 1.47397 3.05703 1.72402C2.80698 1.97407 2.6665 2.31321 2.6665 2.66683V13.3335C2.6665 13.6871 2.80698 14.0263 3.05703 14.2763C3.30708 14.5264 3.64622 14.6668 3.99984 14.6668H11.9998C12.3535 14.6668 12.6926 14.5264 12.9426 14.2763C13.1927 14.0263 13.3332 13.6871 13.3332 13.3335V6.00016L8.6665 1.3335Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 1.3335V6.00016H13.3332",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "section"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2V6H2V2H17ZM17 12V16H2V12H17ZM18 0H1C0.45 0 0 0.45 0 1V7C0 7.55 0.45 8 1 8H18C18.55 8 19 7.55 19 7V1C19 0.45 18.55 0 18 0ZM18 10H1C0.45 10 0 10.45 0 11V17C0 17.55 0.45 18 1 18H18C18.55 18 19 17.55 19 17V11C19 10.45 18.55 10 18 10Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 2H2V6.66667H6.66667V2Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 2H9.3335V6.66667H14.0002V2Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 9.3335H9.3335V14.0002H14.0002V9.3335Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 9.3335H2V14.0002H6.66667V9.3335Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8962 7.5H9.39616C8.47568 7.5 7.72949 8.24619 7.72949 9.16667V16.6667C7.72949 17.5871 8.47568 18.3333 9.39616 18.3333H16.8962C17.8166 18.3333 18.5628 17.5871 18.5628 16.6667V9.16667C18.5628 8.24619 17.8166 7.5 16.8962 7.5Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.396 12.4998H3.56266C3.12064 12.4998 2.69671 12.3242 2.38415 12.0117C2.07159 11.6991 1.896 11.2752 1.896 10.8332V3.33317C1.896 2.89114 2.07159 2.46722 2.38415 2.15466C2.69671 1.8421 3.12064 1.6665 3.56266 1.6665H11.0627C11.5047 1.6665 11.9286 1.8421 12.2412 2.15466C12.5537 2.46722 12.7293 2.89114 12.7293 3.33317V4.1665",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.229492)"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "copy-small"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 9.99967H2.66683C2.31321 9.99967 1.97407 9.8592 1.72402 9.60915C1.47397 9.3591 1.3335 9.01996 1.3335 8.66634V2.66634C1.3335 2.31272 1.47397 1.97358 1.72402 1.72353C1.97407 1.47348 2.31321 1.33301 2.66683 1.33301H8.66683C9.02045 1.33301 9.35959 1.47348 9.60964 1.72353C9.85969 1.97358 10.0002 2.31272 10.0002 2.66634V3.33301",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H5H21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "transparent"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11V17",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "transparent"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11V17",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "transparent"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "trash-small"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 3.99967V2.66634C5.3335 2.31272 5.47397 1.97358 5.72402 1.72353C5.97407 1.47348 6.31321 1.33301 6.66683 1.33301H9.3335C9.68712 1.33301 10.0263 1.47348 10.2763 1.72353C10.5264 1.97358 10.6668 2.31272 10.6668 2.66634V3.99967M12.6668 3.99967V13.333C12.6668 13.6866 12.5264 14.0258 12.2763 14.2758C12.0263 14.5259 11.6871 14.6663 11.3335 14.6663H4.66683C4.31321 14.6663 3.97407 14.5259 3.72402 14.2758C3.47397 14.0258 3.3335 13.6866 3.3335 13.333V3.99967H12.6668Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 7.33301V11.333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 7.33301V11.333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "align-left"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6H3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14H3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18H3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "plus-small"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.3333V20.6667",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 16H20.6668",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5V19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12H19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "plus-circle"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V16",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H16",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "minus"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 16H20.6668",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "calculator"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "-6 -6 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M12.6667 1.33325H3.33333C2.598 1.33325 2 1.93125 2 2.66659V13.3333C2 14.0686 2.598 14.6666 3.33333 14.6666H12.6667C13.402 14.6666 14 14.0686 14 13.3333V2.66659C14 1.93125 13.402 1.33325 12.6667 1.33325ZM3.33333 13.3333V2.66659H12.6667L12.6673 13.3333H3.33333Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M4.66699 8H6.00033V9.33333H4.66699V8ZM4.66699 10.6667H6.00033V12H4.66699V10.6667ZM7.33366 8H8.66699V9.33333H7.33366V8ZM4.66699 4H11.3337V6.66667H4.66699V4ZM7.33366 10.6667H8.66699V12H7.33366V10.6667ZM10.0003 8H11.3337V12H10.0003V8Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "hash"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9H20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3L8 21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3L14 21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "pie-chart"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2099 15.8901C20.5737 17.3946 19.5787 18.7203 18.3118 19.7514C17.0449 20.7825 15.5447 21.4875 13.9424 21.8049C12.34 22.1222 10.6843 22.0422 9.12006 21.5719C7.55578 21.1015 6.13054 20.2551 4.96893 19.1067C3.80733 17.9583 2.94473 16.5428 2.45655 14.984C1.96837 13.4252 1.86948 11.7706 2.16851 10.1647C2.46755 8.55886 3.15541 7.05071 4.17196 5.77211C5.18851 4.49351 6.5028 3.4834 7.99992 2.83008",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2V12H22Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "pie-chart-icon"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2099 15.8901C20.5737 17.3946 19.5787 18.7203 18.3118 19.7514C17.0449 20.7825 15.5447 21.4875 13.9424 21.8049C12.34 22.1222 10.6843 22.0422 9.12006 21.5719C7.55578 21.1015 6.13054 20.2551 4.96893 19.1067C3.80733 17.9583 2.94473 16.5428 2.45655 14.984C1.96837 13.4252 1.86948 11.7706 2.16851 10.1647C2.46755 8.55886 3.15541 7.05071 4.17196 5.77211C5.18851 4.49351 6.5028 3.4834 7.99992 2.83008",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "clipboard"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V20C0 21.1 0.9 22 2 22H16C17.1 22 18 21.1 18 20V4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM16 20H2V4H4V7H14V4H16V20Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "home"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19h3v-6h6v6h3v-9l-6-4.5L6 10Zm-2 2V9l8-6 8 6v12h-7v-6h-2v6Zm8-8.75Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "people"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.75C4.66 8.75 0 9.92 0 12.25V14H14V12.25C14 9.92 9.34 8.75 7 8.75ZM2.34 12C3.18 11.42 5.21 10.75 7 10.75C8.79 10.75 10.82 11.42 11.66 12H2.34ZM7 7C8.93 7 10.5 5.43 10.5 3.5C10.5 1.57 8.93 0 7 0C5.07 0 3.5 1.57 3.5 3.5C3.5 5.43 5.07 7 7 7ZM7 2C7.83 2 8.5 2.67 8.5 3.5C8.5 4.33 7.83 5 7 5C6.17 5 5.5 4.33 5.5 3.5C5.5 2.67 6.17 2 7 2ZM14.04 8.81C15.2 9.65 16 10.77 16 12.25V14H20V12.25C20 10.23 16.5 9.08 14.04 8.81ZM13 7C14.93 7 16.5 5.43 16.5 3.5C16.5 1.57 14.93 0 13 0C12.46 0 11.96 0.13 11.5 0.35C12.13 1.24 12.5 2.33 12.5 3.5C12.5 4.67 12.13 5.76 11.5 6.65C11.96 6.87 12.46 7 13 7Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "book"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M20 1C18.89 0.65 17.67 0.5 16.5 0.5C14.55 0.5 12.45 0.9 11 2C9.55 0.9 7.45 0.5 5.5 0.5C3.55 0.5 1.45 0.9 0 2V16.65C0 16.9 0.25 17.15 0.5 17.15C0.6 17.15 0.65 17.1 0.75 17.1C2.1 16.45 4.05 16 5.5 16C7.45 16 9.55 16.4 11 17.5C12.35 16.65 14.8 16 16.5 16C18.15 16 19.85 16.3 21.25 17.05C21.35 17.1 21.4 17.1 21.5 17.1C21.75 17.1 22 16.85 22 16.6V2C21.4 1.55 20.75 1.25 20 1ZM20 14.5C18.9 14.15 17.7 14 16.5 14C14.8 14 12.35 14.65 11 15.5V4C12.35 3.15 14.8 2.5 16.5 2.5C17.7 2.5 18.9 2.65 20 3V14.5Z",
    fill: "#8C8C8C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.5C17.38 6.5 18.23 6.59 19 6.76V5.24C18.21 5.09 17.36 5 16.5 5C14.8 5 13.26 5.29 12 5.83V7.49C13.13 6.85 14.7 6.5 16.5 6.5Z",
    fill: "#8C8C8C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.49V10.15C13.13 9.51 14.7 9.16 16.5 9.16C17.38 9.16 18.23 9.25 19 9.42V7.9C18.21 7.75 17.36 7.66 16.5 7.66C14.8 7.66 13.26 7.96 12 8.49Z",
    fill: "#8C8C8C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.33C14.8 10.33 13.26 10.62 12 11.16V12.82C13.13 12.18 14.7 11.83 16.5 11.83C17.38 11.83 18.23 11.92 19 12.09V10.57C18.21 10.41 17.36 10.33 16.5 10.33Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "design_services"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8388 5.40115C19.2288 5.01115 19.2288 4.38115 18.8388 3.99115L16.0088 1.16115C15.6188 0.771152 14.9888 0.771152 14.5988 1.16115L10.1088 5.65115L6.21877 1.76115C5.43878 0.981153 4.16877 0.981153 3.38877 1.76115L1.48877 3.66115C0.708774 4.44115 0.708774 5.71115 1.48877 6.49115L5.37877 10.3812L0.868774 14.8912V19.1312H5.10877L9.62877 14.6112L13.5188 18.5012C14.4688 19.4512 15.7488 19.1012 16.3488 18.5012L18.2488 16.6012C19.0288 15.8212 19.0288 14.5512 18.2488 13.7712L14.3588 9.88115L18.8388 5.40115ZM2.90877 5.07115L4.79877 3.17115L6.06877 4.44115L4.88877 5.63115L6.29877 7.04115L7.48877 5.85115L8.68877 7.05115L6.78877 8.95115L2.90877 5.07115ZM14.1388 12.5112L12.9488 13.7012L14.3588 15.1112L15.5488 13.9212L16.8188 15.1912L14.9188 17.0912L11.0288 13.2012L12.9288 11.3012L14.1388 12.5112ZM4.27877 17.1312H2.86877V15.7212L12.4788 6.11115L13.8888 7.52115L4.27877 17.1312ZM13.8888 4.69115L15.2988 3.28115L16.7088 4.69115L15.2988 6.10115L13.8888 4.69115Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "design_screens"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1024 7.39L17.1624 6.33C17.9424 5.55 17.9424 4.28 17.1624 3.5L15.7524 2.09C14.9724 1.31 13.7024 1.31 12.9224 2.09L11.8624 3.15L16.1024 7.39ZM10.4424 4.56L1.25244 13.76V18H5.49244L14.6824 8.81L10.4424 4.56ZM16.2524 14.5C16.2524 16.69 13.7124 18 11.2524 18C10.7024 18 10.2524 17.55 10.2524 17C10.2524 16.45 10.7024 16 11.2524 16C12.7924 16 14.2524 15.27 14.2524 14.5C14.2524 14.03 13.7724 13.63 13.0224 13.3L14.5024 11.82C15.5724 12.45 16.2524 13.29 16.2524 14.5ZM1.83244 10.35C0.862441 9.79 0.252441 9.06 0.252441 8C0.252441 6.2 2.14244 5.37 3.81244 4.64C4.84244 4.18 6.25244 3.56 6.25244 3C6.25244 2.59 5.47244 2 4.25244 2C2.99244 2 2.45244 2.61 2.42244 2.64C2.07244 3.05 1.44244 3.1 1.02244 2.76C0.612441 2.42 0.532441 1.81 0.872441 1.38C0.982441 1.24 2.01244 0 4.25244 0C6.49244 0 8.25244 1.32 8.25244 3C8.25244 4.87 6.32244 5.72 4.61244 6.47C3.67244 6.88 2.25244 7.5 2.25244 8C2.25244 8.31 2.68244 8.6 3.32244 8.86L1.83244 10.35Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "shopping-cart"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5463 11C16.2963 11 16.9563 10.59 17.2963 9.97L20.8763 3.48C21.2463 2.82 20.7663 2 20.0063 2H5.20629L4.26629 0H0.996292V2H2.99629L6.59629 9.59L5.24629 12.03C4.51629 13.37 5.47629 15 6.99629 15H18.9963V13H6.99629L8.09629 11H15.5463ZM6.15629 4H18.3063L15.5463 9H8.52629L6.15629 4ZM6.99629 16C5.89629 16 5.00629 16.9 5.00629 18C5.00629 19.1 5.89629 20 6.99629 20C8.09629 20 8.99629 19.1 8.99629 18C8.99629 16.9 8.09629 16 6.99629 16ZM16.9963 16C15.8963 16 15.0063 16.9 15.0063 18C15.0063 19.1 15.8963 20 16.9963 20C18.0963 20 18.9963 19.1 18.9963 18C18.9963 16.9 18.0963 16 16.9963 16Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "team"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 20V16C1 15.5167 1.17083 15.1042 1.5125 14.7625C1.85417 14.4208 2.26667 14.25 2.75 14.25H6.275C6.55833 14.25 6.82917 14.3208 7.0875 14.4625C7.34583 14.6042 7.56667 14.8 7.75 15.05C8.23333 15.75 8.85 16.2917 9.6 16.675C10.35 17.0583 11.15 17.25 12 17.25C12.85 17.25 13.65 17.0583 14.4 16.675C15.15 16.2917 15.775 15.75 16.275 15.05C16.4583 14.8 16.675 14.6042 16.925 14.4625C17.175 14.3208 17.4417 14.25 17.725 14.25H21.25C21.7333 14.25 22.1458 14.4208 22.4875 14.7625C22.8292 15.1042 23 15.5167 23 16V20H16.5V17.025C15.9 17.575 15.2125 18 14.4375 18.3C13.6625 18.6 12.85 18.75 12 18.75C11.15 18.75 10.3417 18.6 9.575 18.3C8.80833 18 8.11667 17.575 7.5 17.025V20H1ZM12 15.75C11.4167 15.75 10.8542 15.6125 10.3125 15.3375C9.77083 15.0625 9.33333 14.6833 9 14.2C8.73333 13.8167 8.4125 13.5083 8.0375 13.275C7.6625 13.0417 7.25833 12.8833 6.825 12.8C7.30833 12.3 8.06667 11.9167 9.1 11.65C10.1333 11.3833 11.1 11.25 12 11.25C12.9 11.25 13.8708 11.3833 14.9125 11.65C15.9542 11.9167 16.7167 12.3 17.2 12.8C16.7667 12.8833 16.3625 13.0417 15.9875 13.275C15.6125 13.5083 15.2917 13.8167 15.025 14.2C14.6917 14.6833 14.2542 15.0625 13.7125 15.3375C13.1708 15.6125 12.6 15.75 12 15.75ZM4 12.5C3.25 12.5 2.60417 12.2292 2.0625 11.6875C1.52083 11.1458 1.25 10.5 1.25 9.75C1.25 8.98333 1.52083 8.33333 2.0625 7.8C2.60417 7.26667 3.25 7 4 7C4.76667 7 5.41667 7.26667 5.95 7.8C6.48333 8.33333 6.75 8.98333 6.75 9.75C6.75 10.5 6.48333 11.1458 5.95 11.6875C5.41667 12.2292 4.76667 12.5 4 12.5ZM20 12.5C19.25 12.5 18.6042 12.2292 18.0625 11.6875C17.5208 11.1458 17.25 10.5 17.25 9.75C17.25 8.98333 17.5208 8.33333 18.0625 7.8C18.6042 7.26667 19.25 7 20 7C20.7667 7 21.4167 7.26667 21.95 7.8C22.4833 8.33333 22.75 8.98333 22.75 9.75C22.75 10.5 22.4833 11.1458 21.95 11.6875C21.4167 12.2292 20.7667 12.5 20 12.5ZM12 9.5C11.25 9.5 10.6042 9.22917 10.0625 8.6875C9.52083 8.14583 9.25 7.5 9.25 6.75C9.25 5.98333 9.52083 5.33333 10.0625 4.8C10.6042 4.26667 11.25 4 12 4C12.7667 4 13.4167 4.26667 13.95 4.8C14.4833 5.33333 14.75 5.98333 14.75 6.75C14.75 7.5 14.4833 8.14583 13.95 8.6875C13.4167 9.22917 12.7667 9.5 12 9.5Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "timesheet"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.5C18.99 10.5 20.37 10.97 21.5 11.76V7.5C21.5 6.39 20.61 5.5 19.5 5.5H15.5V3.5C15.5 2.39 14.61 1.5 13.5 1.5H9.5C8.39 1.5 7.5 2.39 7.5 3.5V5.5H3.5C2.39 5.5 1.51 6.39 1.51 7.5L1.5 18.5C1.5 19.61 2.39 20.5 3.5 20.5H11.18C10.75 19.59 10.5 18.58 10.5 17.5C10.5 13.63 13.63 10.5 17.5 10.5ZM9.5 3.5H13.5V5.5H9.5V3.5Z",
    fill: "#8C8C8C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.5C14.74 12.5 12.5 14.74 12.5 17.5C12.5 20.26 14.74 22.5 17.5 22.5C20.26 22.5 22.5 20.26 22.5 17.5C22.5 14.74 20.26 12.5 17.5 12.5ZM19.15 19.85L17 17.7V14.5H18V17.29L19.85 19.14L19.15 19.85Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "person"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.00002C7.47334 6.00002 8.66667 4.80669 8.66667 3.33335C8.66667 1.86002 7.47334 0.666687 6 0.666687C4.52667 0.666687 3.33334 1.86002 3.33334 3.33335C3.33334 4.80669 4.52667 6.00002 6 6.00002ZM6 7.33335C4.22 7.33335 0.666672 8.22669 0.666672 10V11.3334H11.3333V10C11.3333 8.22669 7.78 7.33335 6 7.33335Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "operation-signs"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 0H2.66667C1.2 0 0 1.2 0 2.66667V21.3333C0 22.8 1.2 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V2.66667C24 1.2 22.8 0 21.3333 0ZM13.3733 5.41333L14.7867 4L16.6667 5.88L18.5467 4L19.96 5.41333L18.08 7.29333L19.96 9.17333L18.5467 10.5867L16.6667 8.72L14.7867 10.6L13.3733 9.18667L15.2533 7.30667L13.3733 5.41333ZM4.33333 6.29333H11V8.29333H4.33333V6.29333ZM11.3333 17.3333H8.66667V20H6.66667V17.3333H4V15.3333H6.66667V12.6667H8.66667V15.3333H11.3333V17.3333ZM20 19H13.3333V17H20V19ZM20 15.6667H13.3333V13.6667H20V15.6667Z",
    fill: "#595959"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "visits"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8983 4.89L18.8483 1.52C18.6283 0.62 17.8483 0 16.9383 0H3.04831C2.14831 0 1.35831 0.63 1.14831 1.52L0.0983051 4.89C-0.361695 6.86 0.948305 8 0.998305 8.06V16C0.998305 17.1 1.89831 18 2.99831 18H16.9983C18.0983 18 18.9983 17.1 18.9983 16V8.06C20.1183 6.94 20.0883 5.65 19.8983 4.89ZM10.9983 2H12.9583L13.4983 5.52C13.5883 6.23 13.1083 7 12.2183 7C11.5483 7 10.9983 6.41 10.9983 5.69V2ZM4.43831 5.86C4.35831 6.51 3.83831 7 3.22831 7C2.29831 7 1.87831 6.03 2.03831 5.36L3.04831 2H5.01831L4.43831 5.86ZM8.99831 5.69C8.99831 6.41 8.44831 7 7.70831 7C6.95831 7 6.40831 6.3 6.48831 5.52L7.03831 2H8.99831V5.69ZM16.7683 7C16.1583 7 15.6283 6.51 15.5583 5.86L14.9783 2L16.9083 1.99L17.9583 5.36C18.1183 6.03 17.7083 7 16.7683 7Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.00006C17.2626 2.73741 17.5744 2.52907 17.9176 2.38693C18.2608 2.24479 18.6286 2.17163 19 2.17163C19.3714 2.17163 19.7392 2.24479 20.0824 2.38693C20.4256 2.52907 20.7374 2.73741 21 3.00006C21.2626 3.2627 21.471 3.57451 21.6131 3.91767C21.7553 4.26083 21.8284 4.62862 21.8284 5.00006C21.8284 5.37149 21.7553 5.73929 21.6131 6.08245C21.471 6.42561 21.2626 6.73741 21 7.00006L7.5 20.5001L2 22.0001L3.5 16.5001L17 3.00006Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "edit-command-center"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65 39.4h2.65l22-22.05-2.65-2.65-22 22.05Zm31.9-24.2L32.8 7.4l2.1-2.05q1.05-1.1 2.55-1.075Q38.95 4.3 40 5.35l2.65 2.7q1.05 1.05 1.025 2.55-.025 1.5-1.075 2.55Zm-2.05 2.05-25.75 25.8H5v-7.8L30.75 9.5Zm-6.5-1.2-1.35-1.35 2.65 2.65Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M10.29 3.8602L1.82002 18.0002C1.64539 18.3026 1.55299 18.6455 1.55201 18.9947C1.55103 19.3439 1.64151 19.6873 1.81445 19.9907C1.98738 20.2941 2.23675 20.547 2.53773 20.7241C2.83871 20.9012 3.18082 20.9964 3.53002 21.0002H20.47C20.8192 20.9964 21.1613 20.9012 21.4623 20.7241C21.7633 20.547 22.0127 20.2941 22.1856 19.9907C22.3585 19.6873 22.449 19.3439 22.448 18.9947C22.4471 18.6455 22.3547 18.3026 22.18 18.0002L13.71 3.8602C13.5318 3.56631 13.2807 3.32332 12.9812 3.15469C12.6817 2.98605 12.3438 2.89746 12 2.89746C11.6563 2.89746 11.3184 2.98605 11.0188 3.15469C10.7193 3.32332 10.4683 3.56631 10.29 3.8602V3.8602Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V13",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H12.01",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "#8C8C8C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17L21 12L16 7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12H9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2V9H20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "expand-vertical"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 12 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1924 15.6567L5.94974 19.8994L1.7071 15.6567",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7071 5.24268L5.94974 1.00003L10.1924 5.24268",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94967 19.8995L5.94967 9.99996",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94967 0.999959L5.94967 10.8995",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "expand-horizontal"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 22 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74219 9.69238L1.49955 5.44974L5.74219 1.2071",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1563 1.2071L20.3989 5.44974L16.1562 9.69238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49947 5.44967L11.399 5.44967",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M20.399 5.44967L10.4995 5.44967",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8L12 3L7 8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19V5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12L12 5L19 12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up-ward"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8L1.41 9.41L7 3.83V16H9V3.83L14.58 9.42L16 8L8 0L0 8Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.33329H5.22007L8.4734 4.07996C8.7334 3.81996 8.7334 3.39329 8.4734 3.13329C8.2134 2.87329 7.7934 2.87329 7.5334 3.13329L3.14007 7.52663C2.88007 7.78663 2.88007 8.20663 3.14007 8.46663L7.5334 12.86C7.7934 13.12 8.2134 13.12 8.4734 12.86C8.7334 12.6 8.7334 12.18 8.4734 11.92L5.22007 8.66663H12.6667C13.0334 8.66663 13.3334 8.36663 13.3334 7.99996C13.3334 7.63329 13.0334 7.33329 12.6667 7.33329Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19V5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12L12 19L5 12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "rounded-plus"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 8.00004C14.6663 4.31814 11.6816 1.33337 7.99967 1.33337C4.31778 1.33337 1.33301 4.31814 1.33301 8.00004C1.33301 11.6819 4.31778 14.6667 7.99967 14.6667Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33337V10.6667",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 8H10.6663",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "rounded-minus"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8.00004C14.6668 4.31814 11.6821 1.33337 8.00016 1.33337C4.31826 1.33337 1.3335 4.31814 1.3335 8.00004C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667Z",
    stroke: "#EF4C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 8H10.6668",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 41H10.6668",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83341 3.77341C2.90008 3.86008 6.66008 8.66008 6.66008 8.66008V12.6667C6.66008 13.0334 6.96008 13.3334 7.33342 13.3334H8.67342C9.04008 13.3334 9.34675 13.0334 9.34675 12.6667V8.65341C9.34675 8.65341 13.0067 3.97341 13.1801 3.76008C13.3534 3.54675 13.3334 3.33341 13.3334 3.33341C13.3334 2.96675 13.0334 2.66675 12.6601 2.66675H3.34008C2.93341 2.66675 2.66675 2.98675 2.66675 3.33341C2.66675 3.46675 2.70675 3.62675 2.83341 3.77341Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "type"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7V4H20V7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20H15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4V20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "drag"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80811 13C9.36039 13 9.80811 12.5523 9.80811 12C9.80811 11.4477 9.36039 11 8.80811 11C8.25582 11 7.80811 11.4477 7.80811 12C7.80811 12.5523 8.25582 13 8.80811 13Z",
    stroke: "#A2A2A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8081 13C15.3604 13 15.8081 12.5523 15.8081 12C15.8081 11.4477 15.3604 11 14.8081 11C14.2558 11 13.8081 11.4477 13.8081 12C13.8081 12.5523 14.2558 13 14.8081 13Z",
    stroke: "#A2A2A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80811 6C9.36039 6 9.80811 5.55228 9.80811 5C9.80811 4.44772 9.36039 4 8.80811 4C8.25582 4 7.80811 4.44772 7.80811 5C7.80811 5.55228 8.25582 6 8.80811 6Z",
    stroke: "#A2A2A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8081 6C15.3604 6 15.8081 5.55228 15.8081 5C15.8081 4.44772 15.3604 4 14.8081 4C14.2558 4 13.8081 4.44772 13.8081 5C13.8081 5.55228 14.2558 6 14.8081 6Z",
    stroke: "#A2A2A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80811 20C9.36039 20 9.80811 19.5523 9.80811 19C9.80811 18.4477 9.36039 18 8.80811 18C8.25582 18 7.80811 18.4477 7.80811 19C7.80811 19.5523 8.25582 20 8.80811 20Z",
    stroke: "#A2A2A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8081 20C15.3604 20 15.8081 19.5523 15.8081 19C15.8081 18.4477 15.3604 18 14.8081 18C14.2558 18 13.8081 18.4477 13.8081 19C13.8081 19.5523 14.2558 20 14.8081 20Z",
    stroke: "#A2A2A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "check"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6L9 17L4 12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "check-lg"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 8L12.0002 22.6667L5.3335 16",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "check-min"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80001 15.9L4.60001 11.7L3.20001 13.1L8.80001 18.7L20.8 6.69999L19.4 5.29999L8.80001 15.9Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 2.33325H2.33333C1.59695 2.33325 1 2.93021 1 3.66659V12.9999C1 13.7363 1.59695 14.3333 2.33333 14.3333H11.6667C12.403 14.3333 13 13.7363 13 12.9999V3.66659C13 2.93021 12.403 2.33325 11.6667 2.33325Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 1V3.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 1V3.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.33325H13",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-2"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.99984H12.6666V1.33317C12.6666 0.966504 12.3666 0.666504 11.9999 0.666504C11.6333 0.666504 11.3333 0.966504 11.3333 1.33317V1.99984H4.66659V1.33317C4.66659 0.966504 4.36659 0.666504 3.99992 0.666504C3.63325 0.666504 3.33325 0.966504 3.33325 1.33317V1.99984H2.66659C1.93325 1.99984 1.33325 2.59984 1.33325 3.33317V13.9998C1.33325 14.7332 1.93325 15.3332 2.66659 15.3332H13.3333C14.0666 15.3332 14.6666 14.7332 14.6666 13.9998V3.33317C14.6666 2.59984 14.0666 1.99984 13.3333 1.99984ZM12.6666 13.9998H3.33325C2.96659 13.9998 2.66659 13.6998 2.66659 13.3332V5.33317H13.3333V13.3332C13.3333 13.6998 13.0333 13.9998 12.6666 13.9998Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-today"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 1.99996H11.6668V0.666626H10.3335V1.99996H3.66683V0.666626H2.3335V1.99996H1.66683C0.933496 1.99996 0.333496 2.59996 0.333496 3.33329V14C0.333496 14.7333 0.933496 15.3333 1.66683 15.3333H12.3335C13.0668 15.3333 13.6668 14.7333 13.6668 14V3.33329C13.6668 2.59996 13.0668 1.99996 12.3335 1.99996ZM12.3335 14H1.66683V5.33329H12.3335V14Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "content-paste"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.00002H7.88C7.6 1.22669 6.86667 0.666687 6 0.666687C5.13333 0.666687 4.4 1.22669 4.12 2.00002H1.33333C0.6 2.00002 0 2.60002 0 3.33335V14C0 14.7334 0.6 15.3334 1.33333 15.3334H10.6667C11.4 15.3334 12 14.7334 12 14V3.33335C12 2.60002 11.4 2.00002 10.6667 2.00002ZM6 2.00002C6.36667 2.00002 6.66667 2.30002 6.66667 2.66669C6.66667 3.03335 6.36667 3.33335 6 3.33335C5.63333 3.33335 5.33333 3.03335 5.33333 2.66669C5.33333 2.30002 5.63333 2.00002 6 2.00002ZM10.6667 14H1.33333V3.33335H2.66667V5.33335H9.33333V3.33335H10.6667V14Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "playlist-add-check"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 3.33329H0.666504V4.66663H7.99984V3.33329Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 0.666626H0.666504V1.99996H7.99984V0.666626Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 5.99996H0.666504V7.33329H5.33317V5.99996Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3932 4.61996L9.55984 7.44663L8.1465 6.03329L7.2065 6.97329L9.55984 9.33329L13.3332 5.55996L12.3932 4.61996Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "shopping-cart-2"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5C4.175 12.5 3.5075 13.175 3.5075 14C3.5075 14.825 4.175 15.5 5 15.5C5.825 15.5 6.5 14.825 6.5 14C6.5 13.175 5.825 12.5 5 12.5ZM0.5 0.5V2H2L4.7 7.6925L3.6875 9.53C3.5675 9.74 3.5 9.9875 3.5 10.25C3.5 11.075 4.175 11.75 5 11.75H14V10.25H5.315C5.21 10.25 5.1275 10.1675 5.1275 10.0625L5.15 9.9725L5.825 8.75H11.4125C11.975 8.75 12.47 8.4425 12.725 7.9775L15.41 3.11C15.47 3.005 15.5 2.8775 15.5 2.75C15.5 2.3375 15.1625 2 14.75 2H3.6575L2.9525 0.5H0.5ZM12.5 12.5C11.675 12.5 11.0075 13.175 11.0075 14C11.0075 14.825 11.675 15.5 12.5 15.5C13.325 15.5 14 14.825 14 14C14 13.175 13.325 12.5 12.5 12.5Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "sticky-note-2"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.25H1.7425C0.9175 0.25 0.25 0.925 0.25 1.75L0.2575 12.25C0.2575 13.075 0.925 13.75 1.75 13.75H9.25L13.75 9.25V1.75C13.75 0.925 13.075 0.25 12.25 0.25ZM3.25 4H10.75V5.5H3.25V4ZM7 8.5H3.25V7H7V8.5ZM8.5 12.625V8.5H12.625L8.5 12.625Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "phone-enabled"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M11.035 6.0925L9.385 4.4425C9.175 4.2325 9.115 3.94 9.1975 3.6775C9.475 2.8375 9.625 1.9375 9.625 1C9.625 0.5875 9.9625 0.25 10.375 0.25H13C13.4125 0.25 13.75 0.5875 13.75 1C13.75 8.0425 8.0425 13.75 1 13.75C0.5875 13.75 0.25 13.4125 0.25 13V10.3825C0.25 9.97 0.5875 9.6325 1 9.6325C1.93 9.6325 2.8375 9.4825 3.6775 9.205C3.94 9.115 4.24 9.1825 4.4425 9.385L6.0925 11.035C8.215 9.9475 9.955 8.215 11.035 6.0925Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "account-balance-wallet"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 11.5V12.25C14.375 13.075 13.7 13.75 12.875 13.75H2.375C1.5425 13.75 0.875 13.075 0.875 12.25V1.75C0.875 0.925 1.5425 0.25 2.375 0.25H12.875C13.7 0.25 14.375 0.925 14.375 1.75V2.5H7.625C6.7925 2.5 6.125 3.175 6.125 4V10C6.125 10.825 6.7925 11.5 7.625 11.5H14.375ZM7.625 10H15.125V4H7.625V10ZM10.625 8.125C10.0025 8.125 9.5 7.6225 9.5 7C9.5 6.3775 10.0025 5.875 10.625 5.875C11.2475 5.875 11.75 6.3775 11.75 7C11.75 7.6225 11.2475 8.125 10.625 8.125Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "note"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.5L1.25211e-07 5L1.78873e-08 14C8.04929e-09 14.825 0.675 15.5 1.5 15.5L10.5075 15.5C11.3325 15.5 12 14.825 12 14L11.9925 2C11.9925 1.175 11.325 0.5 10.5 0.5L4.5 0.5ZM1.125 5.75L5.25 1.625L5.25 5.75L1.125 5.75Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "verified"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8L15.42 5.9075L15.675 3.14L12.9675 2.525L11.55 0.125L9 1.22L6.45 0.125L5.0325 2.5175L2.325 3.125L2.58 5.9L0.75 8L2.58 10.0925L2.325 12.8675L5.0325 13.4825L6.45 15.875L9 14.7725L11.55 15.8675L12.9675 13.475L15.675 12.86L15.42 10.0925L17.25 8ZM7.5675 11.54L4.7175 8.6825L5.8275 7.5725L7.5675 9.32L11.955 4.9175L13.065 6.0275L7.5675 11.54Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "external-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11V17C16 17.5304 15.7893 18.0391 15.4142 18.4142C15.0391 18.7893 14.5304 19 14 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V6C1 5.46957 1.21071 4.96086 1.58579 4.58579C1.96086 4.21071 2.46957 4 3 4H9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1H19V7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12L19 1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2V9H20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1162 13.4336H10.1245",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.8335,
    y: 2.5,
    width: 8.33333,
    height: 14.1667,
    rx: 2,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#A2A2A2",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5,
    fill: "#A2A2A2"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "tablet"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 1.66602H5.00016C4.07969 1.66602 3.3335 2.41221 3.3335 3.33268V16.666C3.3335 17.5865 4.07969 18.3327 5.00016 18.3327H15.0002C15.9206 18.3327 16.6668 17.5865 16.6668 16.666V3.33268C16.6668 2.41221 15.9206 1.66602 15.0002 1.66602Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H10.0083",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "desktop"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 2.5H3.33317C2.4127 2.5 1.6665 3.24619 1.6665 4.16667V12.5C1.6665 13.4205 2.4127 14.1667 3.33317 14.1667H16.6665C17.587 14.1667 18.3332 13.4205 18.3332 12.5V4.16667C18.3332 3.24619 17.587 2.5 16.6665 2.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 17.5H13.3332",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.166V17.4993",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "map-pin"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#8C8C8C"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "search"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 13.1667C10.2789 13.1667 12.6667 10.7789 12.6667 7.83333C12.6667 4.88781 10.2789 2.5 7.33333 2.5C4.38781 2.5 2 4.88781 2 7.83333C2 10.7789 4.38781 13.1667 7.33333 13.1667Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5L11.1 11.6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "scoring"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3,
    fill: "#A2A2A2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "#A2A2A2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3,
    fill: "#A2A2A2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 20,
    height: 2
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "rating-star"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0.49 0 16.49 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49935 1.41699L10.6881 5.85116L15.5827 6.56658L12.041 10.0162L12.8768 14.8895L8.49935 12.5874L4.12185 14.8895L4.95768 10.0162L1.41602 6.56658L6.3106 5.85116L8.49935 1.41699Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "rating-circle"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "-1 -1 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "rating-box"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,8v5l4.25,2.52l0.77-1.28l-3.52-2.09V8H11z M21,10V3l-2.64,2.64C16.74,4.01,14.49,3,12,3c-4.97,0-9,4.03-9,9 s4.03,9,9,9s9-4.03,9-9h-2c0,3.86-3.14,7-7,7s-7-3.14-7-7s3.14-7,7-7c1.93,0,3.68,0.79,4.95,2.05L14,10H21z"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "check-square"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11L12 14L22 4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "remove-option"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6L6 18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6L18 18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "image"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#8C8C8C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L16 10L5 21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "bar-chart"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H4V7H6V14ZM10 14H8V4H10V14ZM14 14H12V10H14V14ZM16 16H2V2H16V16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 4.66669H9.3335C8.96683 4.66669 8.66683 4.96669 8.66683 5.33335C8.66683 5.70002 8.96683 6.00002 9.3335 6.00002H11.3335C12.4335 6.00002 13.3335 6.90002 13.3335 8.00002C13.3335 9.10002 12.4335 10 11.3335 10H9.3335C8.96683 10 8.66683 10.3 8.66683 10.6667C8.66683 11.0334 8.96683 11.3334 9.3335 11.3334H11.3335C13.1735 11.3334 14.6668 9.84002 14.6668 8.00002C14.6668 6.16002 13.1735 4.66669 11.3335 4.66669ZM5.3335 8.00002C5.3335 8.36669 5.6335 8.66669 6.00016 8.66669H10.0002C10.3668 8.66669 10.6668 8.36669 10.6668 8.00002C10.6668 7.63335 10.3668 7.33335 10.0002 7.33335H6.00016C5.6335 7.33335 5.3335 7.63335 5.3335 8.00002ZM6.66683 10H4.66683C3.56683 10 2.66683 9.10002 2.66683 8.00002C2.66683 6.90002 3.56683 6.00002 4.66683 6.00002H6.66683C7.0335 6.00002 7.3335 5.70002 7.3335 5.33335C7.3335 4.96669 7.0335 4.66669 6.66683 4.66669H4.66683C2.82683 4.66669 1.3335 6.16002 1.3335 8.00002C1.3335 9.84002 2.82683 11.3334 4.66683 11.3334H6.66683C7.0335 11.3334 7.3335 11.0334 7.3335 10.6667C7.3335 10.3 7.0335 10 6.66683 10Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "code"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70431 10.7894L2.99103 8L5.70431 5.21055C5.97564 4.93161 5.97564 4.48815 5.70431 4.20921C5.43298 3.93026 5.00164 3.93026 4.73031 4.20921L1.53699 7.49218C1.26566 7.77112 1.26566 8.22173 1.53699 8.50067L4.73031 11.7908C5.00164 12.0697 5.43298 12.0697 5.70431 11.7908C5.97564 11.5118 5.97564 11.0684 5.70431 10.7894ZM10.296 10.7894L13.0093 8L10.296 5.21055C10.0247 4.93161 10.0247 4.48815 10.296 4.20921C10.5673 3.93026 10.9987 3.93026 11.27 4.20921L14.4633 7.49218C14.7347 7.77112 14.7347 8.22173 14.4633 8.50067L11.27 11.7908C10.9987 12.0697 10.5673 12.0697 10.296 11.7908C10.0247 11.5118 10.0247 11.0684 10.296 10.7894Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "info-card"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5285 11.881L6.06183 8.34769L8.2285 10.5144C8.50183 10.7877 8.94183 10.7744 9.19516 10.4877L13.9752 5.10769C14.2085 4.84769 14.1952 4.44769 13.9485 4.19435C13.6818 3.92769 13.2352 3.93435 12.9818 4.22102L8.72183 9.00769L6.5285 6.81436C6.2685 6.55436 5.8485 6.55436 5.5885 6.81436L1.5285 10.881C1.2685 11.141 1.2685 11.561 1.5285 11.821L1.5885 11.881C1.8485 12.141 2.27516 12.141 2.5285 11.881Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "datatable"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 3.33334V12.6667H13.9998V3.33334H2.6665ZM5.33317 4.66667V6H3.99984V4.66667H5.33317ZM3.99984 8.66667V7.33334H5.33317V8.66667H3.99984ZM3.99984 10H5.33317V11.3333H3.99984V10ZM12.6665 11.3333H6.6665V10H12.6665V11.3333ZM12.6665 8.66667H6.6665V7.33334H12.6665V8.66667ZM12.6665 6H6.6665V4.66667H12.6665V6Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "notes"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 1.33333V7.33333H7.33333V10.6667H1.33333V1.33333H10.6667ZM10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H8L12 8V1.33333C12 0.6 11.4 0 10.6667 0ZM6 7.33333H2.66667V6H6V7.33333ZM9.33333 4.66667H2.66667V3.33333H9.33333V4.66667Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "insights"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.49999L13.5 3.66666L15.3334 2.83332L13.5 1.99999L12.6667 0.166656L11.8334 1.99999L10 2.83332L11.8334 3.66666L12.6667 5.49999ZM7.66669 5.83332L6.00002 2.16666L4.33335 5.83332L0.666687 7.49999L4.33335 9.16666L6.00002 12.8333L7.66669 9.16666L11.3334 7.49999L7.66669 5.83332ZM12.6667 9.49999L11.8334 11.3333L10 12.1667L11.8334 13L12.6667 14.8333L13.5 13L15.3334 12.1667L13.5 11.3333L12.6667 9.49999Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "lines-chart"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5285 11.881L6.06183 8.34769L8.2285 10.5144C8.50183 10.7877 8.94183 10.7744 9.19516 10.4877L13.9752 5.10769C14.2085 4.84769 14.1952 4.44769 13.9485 4.19435C13.6818 3.92769 13.2352 3.93435 12.9818 4.22102L8.72183 9.00769L6.5285 6.81436C6.2685 6.55436 5.8485 6.55436 5.5885 6.81436L1.5285 10.881C1.2685 11.141 1.2685 11.561 1.5285 11.821L1.5885 11.881C1.8485 12.141 2.27516 12.141 2.5285 11.881Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "lines-chart-v2"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5285 11.881L6.06183 8.34769L8.2285 10.5144C8.50183 10.7877 8.94183 10.7744 9.19516 10.4877L13.9752 5.10769C14.2085 4.84769 14.1952 4.44769 13.9485 4.19435C13.6818 3.92769 13.2352 3.93435 12.9818 4.22102L8.72183 9.00769L6.5285 6.81436C6.2685 6.55436 5.8485 6.55436 5.5885 6.81436L1.5285 10.881C1.2685 11.141 1.2685 11.561 1.5285 11.821L1.5885 11.881C1.8485 12.141 2.27516 12.141 2.5285 11.881Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "accordion"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 2.66634C10.9402 2.66634 13.3335 5.05967 13.3335 7.99967C13.3335 10.9397 10.9402 13.333 8.00016 13.333C5.06016 13.333 2.66683 10.9397 2.66683 7.99967C2.66683 5.05967 5.06016 2.66634 8.00016 2.66634ZM8.00016 1.33301C4.32016 1.33301 1.3335 4.31967 1.3335 7.99967C1.3335 11.6797 4.32016 14.6663 8.00016 14.6663C11.6802 14.6663 14.6668 11.6797 14.6668 7.99967C14.6668 4.31967 11.6802 1.33301 8.00016 1.33301ZM8.00016 9.99967L5.3335 7.33301H10.6668L8.00016 9.99967Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "stack-bars"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 8,8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66634H6V13.333H4V6.66634ZM4 3.33301H6V5.99967H4V3.33301ZM10.6667 10.6663H12.6667V13.333H10.6667V10.6663ZM10.6667 8.66634H12.6667V9.99967H10.6667V8.66634ZM7.33333 8.66634H9.33333V13.333H7.33333V8.66634ZM7.33333 5.99967H9.33333V7.99967H7.33333V5.99967Z",
    fill: "currentColor"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "speedometer"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M20.35 31.75Q21.5 32.9 23.675 32.825Q25.85 32.75 26.85 31.2L37.65 14.25L20.9 25.2Q19.4 26.2 19.3 28.4Q19.2 30.6 20.35 31.75ZM9.6 40Q8.75 40 7.925 39.575Q7.1 39.15 6.7 38.35Q5.4 35.95 4.7 33.475Q4 31 4 28.2Q4 24.05 5.575 20.375Q7.15 16.7 9.85 13.975Q12.55 11.25 16.175 9.65Q19.8 8.05 23.9 8.05Q26.75 8.05 29.85 8.975Q32.95 9.9 35.8 12.15L33.2 14Q30.95 12.5 28.375 11.775Q25.8 11.05 23.9 11.05Q16.9 11.05 11.95 16.05Q7 21.05 7 28.2Q7 30.45 7.625 32.75Q8.25 35.05 9.4 37H38.35Q39.45 35.2 40.1 32.8Q40.75 30.4 40.75 28.1Q40.75 26 40.125 23.575Q39.5 21.15 37.9 19.1L39.85 16.5Q41.75 19.3 42.7 22.125Q43.65 24.95 43.75 27.8Q43.85 30.8 43.15 33.45Q42.45 36.1 41.1 38.35Q40.5 39.5 39.825 39.75Q39.15 40 38.15 40ZM23.45 24.6Q23.45 24.6 23.45 24.6Q23.45 24.6 23.45 24.6Q23.45 24.6 23.45 24.6Q23.45 24.6 23.45 24.6Q23.45 24.6 23.45 24.6Q23.45 24.6 23.45 24.6Q23.45 24.6 23.45 24.6Q23.45 24.6 23.45 24.6Q23.45 24.6 23.45 24.6Q23.45 24.6 23.45 24.6Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "progress-bars"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26683 6.13337H4.40016C4.9135 6.13337 5.3335 6.55337 5.3335 7.06671V11.7334C5.3335 12.2467 4.9135 12.6667 4.40016 12.6667H4.26683C3.7535 12.6667 3.3335 12.2467 3.3335 11.7334V7.06671C3.3335 6.55337 3.7535 6.13337 4.26683 6.13337ZM8.00016 3.33337C8.5135 3.33337 8.9335 3.75337 8.9335 4.26671V11.7334C8.9335 12.2467 8.5135 12.6667 8.00016 12.6667C7.48683 12.6667 7.06683 12.2467 7.06683 11.7334V4.26671C7.06683 3.75337 7.48683 3.33337 8.00016 3.33337ZM11.7335 8.66671C12.2468 8.66671 12.6668 9.08671 12.6668 9.60004V11.7334C12.6668 12.2467 12.2468 12.6667 11.7335 12.6667C11.2202 12.6667 10.8002 12.2467 10.8002 11.7334V9.60004C10.8002 9.08671 11.2202 8.66671 11.7335 8.66671Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "info"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 4.66665H8.66683V5.99998H7.3335V4.66665ZM7.3335 7.33331H8.66683V11.3333H7.3335V7.33331ZM8.00016 1.33331C4.32016 1.33331 1.3335 4.31998 1.3335 7.99998C1.3335 11.68 4.32016 14.6666 8.00016 14.6666C11.6802 14.6666 14.6668 11.68 14.6668 7.99998C14.6668 4.31998 11.6802 1.33331 8.00016 1.33331ZM8.00016 13.3333C5.06016 13.3333 2.66683 10.94 2.66683 7.99998C2.66683 5.05998 5.06016 2.66665 8.00016 2.66665C10.9402 2.66665 13.3335 5.05998 13.3335 7.99998C13.3335 10.94 10.9402 13.3333 8.00016 13.3333Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "info-filled"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33325C4.32016 1.33325 1.3335 4.31992 1.3335 7.99992C1.3335 11.6799 4.32016 14.6666 8.00016 14.6666C11.6802 14.6666 14.6668 11.6799 14.6668 7.99992C14.6668 4.31992 11.6802 1.33325 8.00016 1.33325ZM8.00016 11.3333C7.6335 11.3333 7.3335 11.0333 7.3335 10.6666V7.99992C7.3335 7.63325 7.6335 7.33325 8.00016 7.33325C8.36683 7.33325 8.66683 7.63325 8.66683 7.99992V10.6666C8.66683 11.0333 8.36683 11.3333 8.00016 11.3333ZM8.66683 5.99992H7.3335V4.66659H8.66683V5.99992Z",
    fill: "#CDCDCD"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "image"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "multimedia"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33341 1.33334H4.00008C3.26675 1.33334 2.67341 1.93334 2.67341 2.66667L2.66675 13.3333C2.66675 14.0667 3.26008 14.6667 3.99341 14.6667H12.0001C12.7334 14.6667 13.3334 14.0667 13.3334 13.3333V5.33334L9.33341 1.33334ZM4.00008 13.3333V2.66667H8.66675V6H12.0001V13.3333H4.00008Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "pdf"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 12.6H8.4C9.06 12.6 9.6 12.06 9.6 11.4V10.2C9.6 9.54 9.06 9 8.4 9H6V15H7.2V12.6ZM8.4 10.2H7.2V11.4H8.4V10.2Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 13.8V10.2C14.4 9.54 13.86 9 13.2 9H10.8V15H13.2C13.86 15 14.4 14.46 14.4 13.8ZM13.2 10.2H12V13.8H13.2V10.2Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.6H16.8V15H15.6V9H18V10.2H16.8V11.4H18V12.6Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "doc"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "chat-bubble-outline"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "dashboards"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H4V4H10L10 12ZM10 20H4V16H10L10 20ZM20 20H14V12H20V20ZM14 8V4H20V8H14Z",
    stroke: "#8C8C8C",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "code"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70431 10.7894L2.99103 8L5.70431 5.21055C5.97564 4.93161 5.97564 4.48815 5.70431 4.20921C5.43298 3.93026 5.00164 3.93026 4.73031 4.20921L1.53699 7.49218C1.26566 7.77112 1.26566 8.22173 1.53699 8.50067L4.73031 11.7908C5.00164 12.0697 5.43298 12.0697 5.70431 11.7908C5.97564 11.5118 5.97564 11.0684 5.70431 10.7894ZM10.296 10.7894L13.0093 8L10.296 5.21055C10.0247 4.93161 10.0247 4.48815 10.296 4.20921C10.5673 3.93026 10.9987 3.93026 11.27 4.20921L14.4633 7.49218C14.7347 7.77112 14.7347 8.22173 14.4633 8.50067L11.27 11.7908C10.9987 12.0697 10.5673 12.0697 10.296 11.7908C10.0247 11.5118 10.0247 11.0684 10.296 10.7894Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "datatable"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 3.33334V12.6667H13.9998V3.33334H2.6665ZM5.33317 4.66667V6H3.99984V4.66667H5.33317ZM3.99984 8.66667V7.33334H5.33317V8.66667H3.99984ZM3.99984 10H5.33317V11.3333H3.99984V10ZM12.6665 11.3333H6.6665V10H12.6665V11.3333ZM12.6665 8.66667H6.6665V7.33334H12.6665V8.66667ZM12.6665 6H6.6665V4.66667H12.6665V6Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "settings"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9532 8.65334C12.9799 8.44001 12.9999 8.22668 12.9999 8.00001C12.9999 7.77334 12.9799 7.56001 12.9532 7.34668L14.3599 6.24668C14.4866 6.14668 14.5199 5.96668 14.4399 5.82001L13.1066 3.51334C13.0466 3.40668 12.9332 3.34668 12.8132 3.34668C12.7732 3.34668 12.7332 3.35334 12.6999 3.36668L11.0399 4.03334C10.6932 3.76668 10.3199 3.54668 9.91323 3.38001L9.65989 1.61334C9.63989 1.45334 9.49989 1.33334 9.33323 1.33334H6.66656C6.49989 1.33334 6.35989 1.45334 6.33989 1.61334L6.08656 3.38001C5.67989 3.54668 5.30656 3.77334 4.95989 4.03334L3.29989 3.36668C3.25989 3.35334 3.21989 3.34668 3.17989 3.34668C3.06656 3.34668 2.95323 3.40668 2.89323 3.51334L1.55989 5.82001C1.47323 5.96668 1.51323 6.14668 1.63989 6.24668L3.04656 7.34668C3.01989 7.56001 2.99989 7.78001 2.99989 8.00001C2.99989 8.22001 3.01989 8.44001 3.04656 8.65334L1.63989 9.75334C1.51323 9.85334 1.47989 10.0333 1.55989 10.18L2.89323 12.4867C2.95323 12.5933 3.06656 12.6533 3.18656 12.6533C3.22656 12.6533 3.26656 12.6467 3.29989 12.6333L4.95989 11.9667C5.30656 12.2333 5.67989 12.4533 6.08656 12.62L6.33989 14.3867C6.35989 14.5467 6.49989 14.6667 6.66656 14.6667H9.33323C9.49989 14.6667 9.63989 14.5467 9.65989 14.3867L9.91323 12.62C10.3199 12.4533 10.6932 12.2267 11.0399 11.9667L12.6999 12.6333C12.7399 12.6467 12.7799 12.6533 12.8199 12.6533C12.9332 12.6533 13.0466 12.5933 13.1066 12.4867L14.4399 10.18C14.5199 10.0333 14.4866 9.85334 14.3599 9.75334L12.9532 8.65334ZM11.6332 7.51334C11.6599 7.72001 11.6666 7.86001 11.6666 8.00001C11.6666 8.14001 11.6532 8.28668 11.6332 8.48668L11.5399 9.24001L12.1332 9.70668L12.8532 10.2667L12.3866 11.0733L11.5399 10.7333L10.8466 10.4533L10.2466 10.9067C9.95989 11.12 9.68656 11.28 9.41323 11.3933L8.70656 11.68L8.59989 12.4333L8.46656 13.3333H7.53323L7.40656 12.4333L7.29989 11.68L6.59323 11.3933C6.30656 11.2733 6.03989 11.12 5.77323 10.92L5.16656 10.4533L4.45989 10.74L3.61323 11.08L3.14656 10.2733L3.86656 9.71334L4.45989 9.24668L4.36656 8.49334C4.34656 8.28668 4.33323 8.13334 4.33323 8.00001C4.33323 7.86668 4.34656 7.71334 4.36656 7.51334L4.45989 6.76001L3.86656 6.29334L3.14656 5.73334L3.61323 4.92668L4.45989 5.26668L5.15323 5.54668L5.75323 5.09334C6.03989 4.88001 6.31323 4.72001 6.58656 4.60668L7.29323 4.32001L7.39989 3.56668L7.53323 2.66668H8.45989L8.58656 3.56668L8.69323 4.32001L9.39989 4.60668C9.68656 4.72668 9.95323 4.88001 10.2199 5.08001L10.8266 5.54668L11.5332 5.26001L12.3799 4.92001L12.8466 5.72668L12.1332 6.29334L11.5399 6.76001L11.6332 7.51334ZM7.99989 5.33334C6.52656 5.33334 5.33323 6.52668 5.33323 8.00001C5.33323 9.47334 6.52656 10.6667 7.99989 10.6667C9.47323 10.6667 10.6666 9.47334 10.6666 8.00001C10.6666 6.52668 9.47323 5.33334 7.99989 5.33334ZM7.99989 9.33334C7.26656 9.33334 6.66656 8.73334 6.66656 8.00001C6.66656 7.26668 7.26656 6.66668 7.99989 6.66668C8.73323 6.66668 9.33323 7.26668 9.33323 8.00001C9.33323 8.73334 8.73323 9.33334 7.99989 9.33334Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "settings-filled"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1401 10.94C17.1801 10.64 17.2001 10.33 17.2001 9.99999C17.2001 9.67999 17.1801 9.35999 17.1301 9.05999L19.1601 7.47999C19.3401 7.33999 19.3901 7.06999 19.2801 6.86999L17.3601 3.54999C17.2401 3.32999 16.9901 3.25999 16.7701 3.32999L14.3801 4.28999C13.8801 3.90999 13.3501 3.58999 12.7601 3.34999L12.4001 0.809994C12.3601 0.569994 12.1601 0.399994 11.9201 0.399994H8.08011C7.84011 0.399994 7.65011 0.569994 7.61011 0.809994L7.25011 3.34999C6.66011 3.58999 6.12011 3.91999 5.63011 4.28999L3.24011 3.32999C3.02011 3.24999 2.77011 3.32999 2.65011 3.54999L0.74011 6.86999C0.62011 7.07999 0.66011 7.33999 0.86011 7.47999L2.89011 9.05999C2.84011 9.35999 2.80011 9.68999 2.80011 9.99999C2.80011 10.31 2.82011 10.64 2.87011 10.94L0.84011 12.52C0.66011 12.66 0.61011 12.93 0.72011 13.13L2.64011 16.45C2.76011 16.67 3.01011 16.74 3.23011 16.67L5.62011 15.71C6.12011 16.09 6.65011 16.41 7.24011 16.65L7.60011 19.19C7.65011 19.43 7.84011 19.6 8.08011 19.6H11.9201C12.1601 19.6 12.3601 19.43 12.3901 19.19L12.7501 16.65C13.3401 16.41 13.8801 16.09 14.3701 15.71L16.7601 16.67C16.9801 16.75 17.2301 16.67 17.3501 16.45L19.2701 13.13C19.3901 12.91 19.3401 12.66 19.1501 12.52L17.1401 10.94ZM10.0001 13.6C8.02011 13.6 6.40011 11.98 6.40011 9.99999C6.40011 8.01999 8.02011 6.39999 10.0001 6.39999C11.9801 6.39999 13.6001 8.01999 13.6001 9.99999C13.6001 11.98 11.9801 13.6 10.0001 13.6Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "view-agenda"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 3.33333V6H2.66683V3.33333H12.6668ZM12.6668 10V12.6667H2.66683V10H12.6668ZM13.3335 2H2.00016C1.6335 2 1.3335 2.3 1.3335 2.66667V6.66667C1.3335 7.03333 1.6335 7.33333 2.00016 7.33333H13.3335C13.7002 7.33333 14.0002 7.03333 14.0002 6.66667V2.66667C14.0002 2.3 13.7002 2 13.3335 2ZM13.3335 8.66667H2.00016C1.6335 8.66667 1.3335 8.96667 1.3335 9.33333V13.3333C1.3335 13.7 1.6335 14 2.00016 14H13.3335C13.7002 14 14.0002 13.7 14.0002 13.3333V9.33333C14.0002 8.96667 13.7002 8.66667 13.3335 8.66667Z",
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "circle-warning"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 0.333336C3.31998 0.333336 0.333313 3.32 0.333313 7C0.333313 10.68 3.31998 13.6667 6.99998 13.6667C10.68 13.6667 13.6666 10.68 13.6666 7C13.6666 3.32 10.68 0.333336 6.99998 0.333336ZM6.99998 7.66667C6.63331 7.66667 6.33331 7.36667 6.33331 7V4.33334C6.33331 3.96667 6.63331 3.66667 6.99998 3.66667C7.36665 3.66667 7.66665 3.96667 7.66665 4.33334V7C7.66665 7.36667 7.36665 7.66667 6.99998 7.66667ZM7.66665 10.3333H6.33331V9H7.66665V10.3333Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41333 7.19333C5.37333 9.08 6.92 10.62 8.80667 11.5867L10.2733 10.12C10.4533 9.94 10.72 9.88 10.9533 9.96C11.7 10.2067 12.5067 10.34 13.3333 10.34C13.7 10.34 14 10.64 14 11.0067V13.3333C14 13.7 13.7 14 13.3333 14C7.07333 14 2 8.92667 2 2.66667C2 2.3 2.3 2 2.66667 2H5C5.36667 2 5.66667 2.3 5.66667 2.66667C5.66667 3.5 5.8 4.3 6.04667 5.04667C6.12 5.28 6.06667 5.54 5.88 5.72667L4.41333 7.19333Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "funnel"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 5.66C4.35 5.79 9.99 12.99 9.99 12.99V19C9.99 19.55 10.44 20 11 20H13.01C13.56 20 14.02 19.55 14.02 19V12.98C14.02 12.98 19.51 5.96 19.77 5.64C20.03 5.32 20 5 20 5C20 4.45 19.55 4 18.99 4H5.01C4.4 4 4 4.48 4 5C4 5.2 4.06 5.44 4.25 5.66Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "printer"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5H16V0H4V5H3C1.34 5 0 6.34 0 8V14H4V18H16V14H20V8C20 6.34 18.66 5 17 5ZM6 2H14V5H6V2ZM14 14V16H6V12H14V14ZM16 12V10H4V12H2V8C2 7.45 2.45 7 3 7H17C17.55 7 18 7.45 18 8V12H16Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "export"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 17",
    strokeWidth: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H10V0H4V6H0L7 13L14 6ZM6 8V2H4V8H3.1L7 10.17L4.83 2H6ZM0 15H14V17H0V15Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "download"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "-4 -2 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 6.5H9.99992V2.5H5.99992V6.5H3.33325L7.99992 11.1667L12.6666 6.5ZM3.33325 12.5V13.8333H12.6666V12.5H3.33325Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "attention"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 0.333328C7.79992 0.333328 0.333252 7.8 0.333252 17C0.333252 26.2 7.79992 33.6667 16.9999 33.6667C26.1999 33.6667 33.6666 26.2 33.6666 17C33.6666 7.8 26.1999 0.333328 16.9999 0.333328ZM16.9999 18.6667C16.0833 18.6667 15.3333 17.9167 15.3333 17V10.3333C15.3333 9.41666 16.0833 8.66666 16.9999 8.66666C17.9166 8.66666 18.6666 9.41666 18.6666 10.3333V17C18.6666 17.9167 17.9166 18.6667 16.9999 18.6667ZM18.6666 25.3333H15.3333V22H18.6666V25.3333Z",
    fill: "#595959"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "solid-line"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8,
    x2: 16,
    y2: 8,
    strokeWidth: 4
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "dashed-line"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8,
    x2: 16,
    y2: 8,
    strokeWidth: 4,
    strokeDasharray: 2
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "view"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 18 20",
    stroke: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.5L15 0L13.5 1.5L12 0L10.5 1.5L9 0L7.5 1.5L6 0L4.5 1.5L3 0V14H0V17C0 18.66 1.34 20 3 20H15C16.66 20 18 18.66 18 17V0L16.5 1.5ZM12 18H3C2.45 18 2 17.55 2 17V16H12V18ZM16 17C16 17.55 15.55 18 15 18C14.45 18 14 17.55 14 17V14H5V3H16V17Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5H6V7H12V5Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H6V10H12V8Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H13V7H15V5Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H13V10H15V8Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "search-v2"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    strokeWidth: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 9.33335H9.80667L9.62001 9.15335C10.42 8.22001 10.8333 6.94668 10.6067 5.59335C10.2933 3.74001 8.74667 2.26001 6.88 2.03335C4.06 1.68668 1.68667 4.06001 2.03334 6.88001C2.26001 8.74668 3.74001 10.2933 5.59334 10.6067C6.94667 10.8333 8.22001 10.42 9.15334 9.62001L9.33334 9.80668V10.3333L12.1667 13.1667C12.44 13.44 12.8867 13.44 13.16 13.1667C13.4333 12.8933 13.4333 12.4467 13.16 12.1733L10.3333 9.33335ZM6.33334 9.33335C4.67334 9.33335 3.33334 7.99335 3.33334 6.33335C3.33334 4.67335 4.67334 3.33335 6.33334 3.33335C7.99334 3.33335 9.33334 4.67335 9.33334 6.33335C9.33334 7.99335 7.99334 9.33335 6.33334 9.33335Z",
    fill: "currentColor",
    stroke: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "success-alert"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM14.59 5.58L8 12.17L5.41 9.59L4 11L8 15L16 7L14.59 5.58Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "info-alert"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5H11V7H9V5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "danger-alert"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5H11V7H9V5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "warning-alert"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.49L18.53 17.5H3.47L11 4.49ZM11 0.5L0 19.5H22L11 0.5ZM12 14.5H10V16.5H12V14.5ZM12 8.5H10V12.5H12V8.5Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "dashboard_customize"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6h16.5v16.5H6Zm3 2.95v9.4ZM25.5 6H42v16.5H25.5Zm4.15 2.95v9.4ZM6 25.5h16.5V42H6Zm3 4.05V39Zm23.25-4.05h3v6.75H42v3h-6.75V42h-3v-6.75H25.5v-3h6.75ZM28.5 9v10.5H39V9ZM9 9v10.5h10.5V9Zm0 19.5V39h10.5V28.5Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "ios-share"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 47.5q-1.45 0-2.55-1.1-1.1-1.1-1.1-2.55v-25.7q0-1.45 1.1-2.55 1.1-1.1 2.55-1.1h8.25v3.65H10.9v25.7h26.25v-25.7H28.8V14.5h8.35q1.45 0 2.55 1.1 1.1 1.1 1.1 2.55v25.7q0 1.45-1.1 2.55-1.1 1.1-2.55 1.1Zm11.25-15.8V7.5L18 11.65l-2.65-2.6 8.6-8.6 8.6 8.6-2.6 2.6L25.8 7.5v24.2Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "location"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 0.333328C2.41992 0.333328 0.333252 2.42 0.333252 5C0.333252 8.5 4.99992 13.6667 4.99992 13.6667C4.99992 13.6667 9.66659 8.5 9.66659 5C9.66659 2.42 7.57992 0.333328 4.99992 0.333328ZM4.99992 6.66666C4.07992 6.66666 3.33325 5.92 3.33325 5C3.33325 4.07999 4.07992 3.33333 4.99992 3.33333C5.91992 3.33333 6.66659 4.07999 6.66659 5C6.66659 5.92 5.91992 6.66666 4.99992 6.66666Z",
    fill: ""
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "phone-contact"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58667 5.19333L8.12 3.72667C7.93333 3.54 7.88 3.28 7.95333 3.04667C8.2 2.3 8.33333 1.5 8.33333 0.666667C8.33333 0.3 8.63333 0 9 0H11.3333C11.7 0 12 0.3 12 0.666667C12 6.92667 6.92667 12 0.666667 12C0.3 12 0 11.7 0 11.3333V9.00667C0 8.64 0.3 8.34 0.666667 8.34C1.49333 8.34 2.3 8.20667 3.04667 7.96C3.28 7.88 3.54667 7.94 3.72667 8.12L5.19333 9.58667C7.08 8.62 8.62667 7.08 9.58667 5.19333Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "trending_down"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "-5 -6 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 8.5L11.1933 6.97333L7.94 3.72L5.27333 6.38667L0.333332 1.44L1.27333 0.5L5.27333 4.5L7.94 1.83333L12.14 6.02667L13.6667 4.5V8.5H9.66667Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "done"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 -2 15 15",
    fill: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23327 7.76252L1.25827 4.78751L0.266602 5.77918L4.23327 9.74585L12.7333 1.24585L11.7416 0.254181L4.23327 7.76252Z",
    fill: "#3498DA"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_forward_ios"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11499 20.23L7.88499 22L17.885 12L7.88499 2L6.11499 3.77L14.345 12L6.11499 20.23Z",
    fill: "#BFBFBF"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_back_ios_new"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M17.885 3.77L16.115 2L6.11499 12L16.115 22L17.885 20.23L9.65499 12L17.885 3.77Z",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "location-filled"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 0.333328C2.41998 0.333328 0.333313 2.42 0.333313 5C0.333313 8.5 4.99998 13.6667 4.99998 13.6667C4.99998 13.6667 9.66665 8.5 9.66665 5C9.66665 2.42 7.57998 0.333328 4.99998 0.333328ZM4.99998 6.66666C4.07998 6.66666 3.33331 5.92 3.33331 5C3.33331 4.07999 4.07998 3.33333 4.99998 3.33333C5.91998 3.33333 6.66665 4.07999 6.66665 5C6.66665 5.92 5.91998 6.66666 4.99998 6.66666Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "productivity"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 17 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0.462524 11.9997V10.2372C0.462524 9.79971 0.575024 9.40283 0.800024 9.04658C1.02502 8.69033 1.33752 8.42471 1.73752 8.24971C2.48752 7.92471 3.25627 7.65596 4.04377 7.44346C4.83127 7.23096 5.63752 7.12471 6.46252 7.12471C7.10002 7.12471 7.7344 7.19033 8.36565 7.32158C8.9969 7.45283 9.61252 7.63096 10.2125 7.85596C10.075 7.99346 9.94377 8.13408 9.81877 8.27783C9.69377 8.42158 9.58127 8.58096 9.48127 8.75596C8.99377 8.58096 8.50002 8.45283 8.00002 8.37158C7.50002 8.29033 6.98752 8.24971 6.46252 8.24971C5.71252 8.24971 4.98127 8.34346 4.26877 8.53096C3.55627 8.71846 2.86252 8.96221 2.18752 9.26221C2.00002 9.34971 1.85315 9.48096 1.7469 9.65596C1.64065 9.83096 1.58752 10.0247 1.58752 10.2372V10.8747H8.76877C8.75627 11.0622 8.75627 11.2497 8.76877 11.4372C8.78127 11.6247 8.80002 11.8122 8.82502 11.9997H0.462524ZM6.46252 5.98096C5.67502 5.98096 5.0094 5.70908 4.46565 5.16533C3.9219 4.62158 3.65002 3.95596 3.65002 3.16846C3.65002 2.38096 3.9219 1.71533 4.46565 1.17158C5.0094 0.627832 5.67502 0.355957 6.46252 0.355957C7.25002 0.355957 7.91565 0.627832 8.4594 1.17158C9.00315 1.71533 9.27502 2.38096 9.27502 3.16846C9.27502 3.95596 9.00315 4.62158 8.4594 5.16533C7.91565 5.70908 7.25002 5.98096 6.46252 5.98096ZM6.46252 4.85596C6.93752 4.85596 7.33752 4.69346 7.66252 4.36846C7.98752 4.04346 8.15002 3.64346 8.15002 3.16846C8.15002 2.69346 7.98752 2.29346 7.66252 1.96846C7.33752 1.64346 6.93752 1.48096 6.46252 1.48096C5.98752 1.48096 5.58752 1.64346 5.26252 1.96846C4.93752 2.29346 4.77502 2.69346 4.77502 3.16846C4.77502 3.64346 4.93752 4.04346 5.26252 4.36846C5.58752 4.69346 5.98752 4.85596 6.46252 4.85596ZM13.2125 3.16846C13.2125 3.95596 12.9406 4.62158 12.3969 5.16533C11.8531 5.70908 11.1875 5.98096 10.4 5.98096C10.2375 5.98096 10.0813 5.97471 9.93127 5.96221C9.78127 5.94971 9.63127 5.91221 9.48127 5.84971C9.81877 5.48721 10.0563 5.07158 10.1938 4.60283C10.3313 4.13408 10.4 3.65596 10.4 3.16846C10.4 2.68096 10.325 2.20596 10.175 1.74346C10.025 1.28096 9.79377 0.862207 9.48127 0.487207C9.63127 0.437207 9.78127 0.402832 9.93127 0.384082C10.0813 0.365332 10.2375 0.355957 10.4 0.355957C11.1875 0.355957 11.8531 0.627832 12.3969 1.17158C12.9406 1.71533 13.2125 2.38096 13.2125 3.16846ZM13.4375 14.8122C12.45 14.8122 11.6094 14.4653 10.9156 13.7716C10.2219 13.0778 9.87502 12.2372 9.87502 11.2497C9.87502 10.2622 10.2219 9.42158 10.9156 8.72783C11.6094 8.03408 12.45 7.68721 13.4375 7.68721C14.425 7.68721 15.2656 8.03408 15.9594 8.72783C16.6531 9.42158 17 10.2622 17 11.2497C17 12.2372 16.6531 13.0778 15.9594 13.7716C15.2656 14.4653 14.425 14.8122 13.4375 14.8122ZM12.725 12.7872L15.2375 10.2747L14.8438 9.88096L12.725 11.9997L11.675 10.931L11.2813 11.3247L12.725 12.7872Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z",
    fill: "#EF4C00"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "editable"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0588 6.02L12.9788 6.94L3.91878 16H2.99878V15.08L12.0588 6.02ZM15.6588 0C15.4088 0 15.1488 0.1 14.9588 0.29L13.1288 2.12L16.8788 5.87L18.7088 4.04C19.0988 3.65 19.0988 3.02 18.7088 2.63L16.3688 0.29C16.1688 0.09 15.9188 0 15.6588 0ZM12.0588 3.19L0.998779 14.25V18H4.74878L15.8088 6.94L12.0588 3.19Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "multiple_productivity"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 1.6V0H16V1.6H9.6ZM9.6 4.8V3.2H16V4.8H9.6ZM9.6 8V6.4H16V8H9.6ZM4.8 7.2C4.13333 7.2 3.56667 6.96667 3.1 6.5C2.63333 6.03333 2.4 5.46667 2.4 4.8C2.4 4.13333 2.63333 3.56667 3.1 3.1C3.56667 2.63333 4.13333 2.4 4.8 2.4C5.46667 2.4 6.03333 2.63333 6.5 3.1C6.96667 3.56667 7.2 4.13333 7.2 4.8C7.2 5.46667 6.96667 6.03333 6.5 6.5C6.03333 6.96667 5.46667 7.2 4.8 7.2ZM0 12V10.48C0 10.2 0.0666667 9.93333 0.2 9.68C0.333333 9.42667 0.52 9.22667 0.76 9.08C1.36 8.72 1.99667 8.45 2.67 8.27C3.34333 8.09 4.05333 8 4.8 8C5.54667 8 6.25667 8.09 6.93 8.27C7.60333 8.45 8.24 8.72 8.84 9.08C9.08 9.22667 9.26667 9.42667 9.4 9.68C9.53333 9.93333 9.6 10.2 9.6 10.48V12H0ZM1.72 10.4H7.88C7.41333 10.1333 6.92 9.93333 6.4 9.8C5.88 9.66667 5.34667 9.6 4.8 9.6C4.25333 9.6 3.72 9.66667 3.2 9.8C2.68 9.93333 2.18667 10.1333 1.72 10.4ZM4.8 5.6C5.02667 5.6 5.21667 5.52333 5.37 5.37C5.52333 5.21667 5.6 5.02667 5.6 4.8C5.6 4.57333 5.52333 4.38333 5.37 4.23C5.21667 4.07667 5.02667 4 4.8 4C4.57333 4 4.38333 4.07667 4.23 4.23C4.07667 4.38333 4 4.57333 4 4.8C4 5.02667 4.07667 5.21667 4.23 5.37C4.38333 5.52333 4.57333 5.6 4.8 5.6Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z",
    fill: "#EF4C00"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "multiple_delete"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93334 9L9.33334 7.6L10.7333 9L11.6667 8.06667L10.2667 6.66667L11.6667 5.26667L10.7333 4.33333L9.33334 5.73333L7.93334 4.33333L7.00001 5.26667L8.40001 6.66667L7.00001 8.06667L7.93334 9ZM5.33334 12C4.96668 12 4.65279 11.8694 4.39168 11.6083C4.13057 11.3472 4.00001 11.0333 4.00001 10.6667V2.66667C4.00001 2.3 4.13057 1.98611 4.39168 1.725C4.65279 1.46389 4.96668 1.33333 5.33334 1.33333H13.3333C13.7 1.33333 14.0139 1.46389 14.275 1.725C14.5361 1.98611 14.6667 2.3 14.6667 2.66667V10.6667C14.6667 11.0333 14.5361 11.3472 14.275 11.6083C14.0139 11.8694 13.7 12 13.3333 12H5.33334ZM5.33334 10.6667H13.3333V2.66667H5.33334V10.6667ZM2.66668 14.6667C2.30001 14.6667 1.98612 14.5361 1.72501 14.275C1.4639 14.0139 1.33334 13.7 1.33334 13.3333V4H2.66668V13.3333H12V14.6667H2.66668Z",
    fill: "#EF4C00"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "sync"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 16 22",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3V0L4 4L8 8V5C11.31 5 14 7.69 14 11C14 12.01 13.75 12.97 13.3 13.8L14.76 15.26C15.54 14.03 16 12.57 16 11C16 6.58 12.42 3 8 3ZM8 17C4.69 17 2 14.31 2 11C2 9.99 2.25 9.03 2.7 8.2L1.24 6.74C0.46 7.97 0 9.43 0 11C0 15.42 3.58 19 8 19V22L12 18L8 14V17Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8C15 9.47825 14.532 10.9186 13.6631 12.1145C12.7942 13.3104 11.569 14.2006 10.1631 14.6574C8.75721 15.1142 7.24278 15.1142 5.83688 14.6574C4.43098 14.2006 3.20578 13.3104 2.33688 12.1145C1.46798 10.9186 1 9.47825 1 8C1 6.52174 1.46798 5.08144 2.33688 3.8855C3.20578 2.68957 4.43098 1.79941 5.83688 1.3426C7.24279 0.885798 8.75722 0.885799 10.1631 1.3426",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "danger-alert-2"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43012 39.8419H40.5701C44.1635 39.8419 46.4035 35.9452 44.6068 32.8419L27.0368 2.48521C25.2401 -0.618118 20.7601 -0.618118 18.9635 2.48521L1.39345 32.8419C-0.403213 35.9452 1.83679 39.8419 5.43012 39.8419ZM23.0001 23.5085C21.7168 23.5085 20.6668 22.4585 20.6668 21.1752V16.5085C20.6668 15.2252 21.7168 14.1752 23.0001 14.1752C24.2835 14.1752 25.3335 15.2252 25.3335 16.5085V21.1752C25.3335 22.4585 24.2835 23.5085 23.0001 23.5085ZM25.3335 32.8419H20.6668V28.1752H25.3335V32.8419Z",
    fill: "#EF4C00"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "library_add_check"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2V11H5V2H14ZM14 0.5H5C4.175 0.5 3.5 1.175 3.5 2V11C3.5 11.825 4.175 12.5 5 12.5H14C14.825 12.5 15.5 11.825 15.5 11V2C15.5 1.175 14.825 0.5 14 0.5ZM8.3525 9.5L5.75 6.875L6.8 5.8175L8.3525 7.3775L12.2 3.5L13.25 4.5575L8.3525 9.5ZM2 3.5H0.5V14C0.5 14.825 1.175 15.5 2 15.5H12.5V14H2V3.5Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "supervisor_account"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM9.05 17H4.77C5.76 16.5 7.47 16 9 16C9.11 16 9.23 16.01 9.34 16.01C9.68 15.28 10.27 14.68 10.98 14.2C10.25 14.07 9.56 14 9 14C6.66 14 2 15.17 2 17.5V19H9V17.5C9 17.33 9.02 17.16 9.05 17ZM16.5 14.5C14.66 14.5 11 15.51 11 17.5V19H22V17.5C22 15.51 18.34 14.5 16.5 14.5ZM17.71 12.68C18.47 12.25 19 11.44 19 10.5C19 9.12 17.88 8 16.5 8C15.12 8 14 9.12 14 10.5C14 11.44 14.53 12.25 15.29 12.68C15.65 12.88 16.06 13 16.5 13C16.94 13 17.35 12.88 17.71 12.68Z",
    fill: "#BFBFBF"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "storefront"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8978 8.89L20.8478 4.52C20.6278 3.62 19.8478 3 18.9378 3H5.04781C4.14781 3 3.35781 3.63 3.14781 4.52L2.09781 8.89C1.85781 9.91 2.07781 10.95 2.71781 11.77C2.79781 11.88 2.90781 11.96 2.99781 12.06V19C2.99781 20.1 3.89781 21 4.99781 21H18.9978C20.0978 21 20.9978 20.1 20.9978 19V12.06C21.0878 11.97 21.1978 11.88 21.2778 11.78C21.9178 10.96 22.1478 9.91 21.8978 8.89ZM18.9078 4.99L19.9578 9.36C20.0578 9.78 19.9678 10.2 19.7078 10.53C19.5678 10.71 19.2678 11 18.7678 11C18.1578 11 17.6278 10.51 17.5578 9.86L16.9778 5L18.9078 4.99ZM12.9978 5H14.9578L15.4978 9.52C15.5478 9.91 15.4278 10.3 15.1678 10.59C14.9478 10.85 14.6278 11 14.2178 11C13.5478 11 12.9978 10.41 12.9978 9.69V5ZM8.48781 9.52L9.03781 5H10.9978V9.69C10.9978 10.41 10.4478 11 9.70781 11C9.36781 11 9.05781 10.85 8.81781 10.59C8.56781 10.3 8.44781 9.91 8.48781 9.52ZM4.03781 9.36L5.04781 5H7.01781L6.43781 9.86C6.35781 10.51 5.83781 11 5.22781 11C4.73781 11 4.42781 10.71 4.29781 10.53C4.02781 10.21 3.93781 9.78 4.03781 9.36ZM4.99781 19V12.97C5.07781 12.98 5.14781 13 5.22781 13C6.09781 13 6.88781 12.64 7.46781 12.05C8.06781 12.65 8.86781 13 9.77781 13C10.6478 13 11.4278 12.64 12.0078 12.07C12.5978 12.64 13.3978 13 14.2978 13C15.1378 13 15.9378 12.65 16.5378 12.05C17.1178 12.64 17.9078 13 18.7778 13C18.8578 13 18.9278 12.98 19.0078 12.97V19H4.99781Z",
    fill: "#595959"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "error-circle"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.83331C4.32016 1.83331 1.3335 4.81998 1.3335 8.49998C1.3335 12.18 4.32016 15.1666 8.00016 15.1666C11.6802 15.1666 14.6668 12.18 14.6668 8.49998C14.6668 4.81998 11.6802 1.83331 8.00016 1.83331ZM8.66683 11.8333H7.3335V10.5H8.66683V11.8333ZM8.66683 9.16665H7.3335V5.16665H8.66683V9.16665Z",
    fill: "#E74C3B"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "barcode"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14V0H2.125V14H0ZM3 14V0H5V14H3ZM6 14V0H7V14H6ZM9 14V0H11V14H9ZM12 14V0H15V14H12ZM16 14V0H17V14H16ZM19 14V0H22V14H19Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "construction"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3623 33.674L37.6448 40.3914L56.6328 59.3794L63.3503 52.662L44.3623 33.674Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4163 24.0139C55.528 24.0139 60.4997 19.0422 60.4997 12.9305C60.4997 11.0939 59.993 9.38387 59.2013 7.86387L50.6513 16.4139L45.933 11.6955L54.483 3.14553C52.963 2.35387 51.253 1.8472 49.4163 1.8472C43.3047 1.8472 38.333 6.81887 38.333 12.9305C38.333 14.2289 38.5863 15.4639 38.998 16.6039L33.1397 22.4622L27.503 16.8255L29.7513 14.5772L25.2863 10.1122L31.9997 3.39887C28.2947 -0.306133 22.278 -0.306133 18.573 3.39887L7.36299 14.6089L11.828 19.0739H2.89799L0.649658 21.3222L11.8597 32.5322L14.108 30.2839V21.3222L18.573 25.7872L20.8213 23.5389L26.458 29.1755L2.99299 52.6405L9.70633 59.3539L45.743 23.3489C46.883 23.7605 48.118 24.0139 49.4163 24.0139Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "call"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M17.01 12.38C15.78 12.38 14.59 12.18 13.48 11.82C13.13 11.7 12.74 11.79 12.47 12.06L10.9 14.03C8.07 12.68 5.42 10.13 4.01 7.2L5.96 5.54C6.23 5.26 6.31 4.87 6.2 4.52C5.83 3.41 5.64 2.22 5.64 0.99C5.64 0.45 5.19 0 4.65 0H1.19C0.65 0 0 0.24 0 0.99C0 10.28 7.73 18 17.01 18C17.72 18 18 17.37 18 16.82V13.37C18 12.83 17.55 12.38 17.01 12.38Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "message"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 20L4 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM16 12H4V10H16V12ZM16 9H4V7H16V9ZM16 6H4V4H16V6Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57979 1.83L4.14979 0.4C1.74978 2.23 0.169785 5.05 0.0297852 8.25H2.02979C2.17979 5.6 3.53979 3.28 5.57979 1.83ZM17.9698 8.25H19.9698C19.8198 5.05 18.2398 2.23 15.8498 0.4L14.4298 1.83C16.4498 3.28 17.8198 5.6 17.9698 8.25ZM15.9998 8.75C15.9998 5.68 14.3598 3.11 11.4998 2.43V1.75C11.4998 0.92 10.8298 0.25 9.99979 0.25C9.16979 0.25 8.49979 0.92 8.49979 1.75V2.43C5.62979 3.11 3.99979 5.67 3.99979 8.75V13.75L1.99979 15.75V16.75H17.9998V15.75L15.9998 13.75V8.75ZM9.99979 19.75C10.1398 19.75 10.2698 19.74 10.3998 19.71C11.0498 19.57 11.5798 19.13 11.8398 18.53C11.9398 18.29 11.9898 18.03 11.9898 17.75H7.98979C7.99979 18.85 8.88979 19.75 9.99979 19.75Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5H6V2.83333H10V1.5Z",
    fill: "current"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6867 5.76L13.6333 4.81333C13.3467 4.47333 13.0333 4.15333 12.6933 3.87333L11.7467 4.82C10.7133 3.99333 9.41333 3.5 8 3.5C4.68667 3.5 2 6.18667 2 9.5C2 12.8133 4.68 15.5 8 15.5C11.32 15.5 14 12.8133 14 9.5C14 8.08667 13.5067 6.78667 12.6867 5.76ZM8.66667 10.1667H7.33333V6.16667H8.66667V10.1667Z",
    fill: "current"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "car_crash"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 2.16666C9.49301 2.16666 7.99967 3.65999 7.99967 5.49999C7.99967 7.33999 9.49301 8.83332 11.333 8.83332C13.173 8.83332 14.6663 7.33999 14.6663 5.49999C14.6663 3.65999 13.173 2.16666 11.333 2.16666ZM11.6663 6.16666H10.9997V3.49999H11.6663V6.16666ZM11.6663 6.83332V7.49999H10.9997V6.83332H11.6663ZM11.273 10.1667C11.313 10.2733 11.333 10.3867 11.333 10.5C11.333 11.0533 10.8863 11.5 10.333 11.5C9.77967 11.5 9.33301 11.0533 9.33301 10.5C9.33301 10.24 9.43301 10.0067 9.59301 9.82666C8.50634 9.38666 7.61967 8.55332 7.11967 7.49999H3.20634L3.89967 5.49999H6.66634C6.66634 5.03999 6.73301 4.58666 6.85967 4.16666H3.66634C3.22634 4.16666 2.85967 4.44666 2.71967 4.83999L1.33301 8.83332V14.1667C1.33301 14.5333 1.63301 14.8333 1.99967 14.8333H2.66634C3.03301 14.8333 3.33301 14.5333 3.33301 14.1667V13.5H11.333V14.1667C11.333 14.5333 11.633 14.8333 11.9997 14.8333H12.6663C13.033 14.8333 13.333 14.5333 13.333 14.1667V9.71332C12.633 10.0533 11.893 10.1733 11.273 10.1667ZM4.33301 11.5C3.77967 11.5 3.33301 11.0533 3.33301 10.5C3.33301 9.94666 3.77967 9.49999 4.33301 9.49999C4.88634 9.49999 5.33301 9.94666 5.33301 10.5C5.33301 11.0533 4.88634 11.5 4.33301 11.5Z",
    fill: "current"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "alt_route"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52 6.44001L3.57333 7.38668C3.12 6.92668 2.68 6.33334 2.38 5.42668L3.67333 5.10001C3.88667 5.69334 4.18667 6.10001 4.52 6.44001ZM5.33333 3.00001L2.66667 0.333344L0 3.00001H2.01333C2.02667 3.54001 2.06667 4.02668 2.14 4.44668L3.43333 4.12001C3.38667 3.80001 3.35333 3.42001 3.34667 3.00001H5.33333ZM12 3.00001L9.33333 0.333344L6.66667 3.00001H8.66C8.59333 5.45334 7.80667 6.16668 6.96667 6.92001C6.63333 7.21334 6.29333 7.53334 6 7.95334C5.77333 7.62668 5.51333 7.36668 5.24667 7.12668L4.30667 8.06668C4.92667 8.63334 5.33333 9.09334 5.33333 10.3333V13.6667H6.66667V10.3333C6.66667 8.98668 7.14 8.56001 7.86 7.91334C8.78 7.08668 9.91333 6.06001 9.99333 3.00001H12Z",
    fill: "#EF4C00"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "locate"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7C8.79 7 7 8.79 7 11C7 13.21 8.79 15 11 15C13.21 15 15 13.21 15 11C15 8.79 13.21 7 11 7ZM19.94 10C19.48 5.83 16.17 2.52 12 2.06V0H10V2.06C5.83 2.52 2.52 5.83 2.06 10H0V12H2.06C2.52 16.17 5.83 19.48 10 19.94V22H12V19.94C16.17 19.48 19.48 16.17 19.94 12H22V10H19.94ZM11 18C7.13 18 4 14.87 4 11C4 7.13 7.13 4 11 4C14.87 4 18 7.13 18 11C18 14.87 14.87 18 11 18Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "routeStart"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5368 1.40801C13.3768 0.936006 12.9288 0.600006 12.4008 0.600006H3.60078C3.07278 0.600006 2.63278 0.936006 2.46478 1.40801L0.800781 6.20001V12.6C0.800781 13.04 1.16078 13.4 1.60078 13.4H2.40078C2.84078 13.4 3.20078 13.04 3.20078 12.6V11.8H12.8008V12.6C12.8008 13.04 13.1608 13.4 13.6008 13.4H14.4008C14.8408 13.4 15.2008 13.04 15.2008 12.6V6.20001L13.5368 1.40801ZM3.60078 9.40001C2.93678 9.40001 2.40078 8.86401 2.40078 8.20001C2.40078 7.53601 2.93678 7.00001 3.60078 7.00001C4.26478 7.00001 4.80078 7.53601 4.80078 8.20001C4.80078 8.86401 4.26478 9.40001 3.60078 9.40001ZM12.4008 9.40001C11.7368 9.40001 11.2008 8.86401 11.2008 8.20001C11.2008 7.53601 11.7368 7.00001 12.4008 7.00001C13.0648 7.00001 13.6008 7.53601 13.6008 8.20001C13.6008 8.86401 13.0648 9.40001 12.4008 9.40001ZM2.40078 5.40001L3.60078 1.80001H12.4008L13.6008 5.40001H2.40078Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "shiftStart"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M10.64 11.76L11.76 10.64L8.8 7.68V4H7.2V8.32L10.64 11.76ZM8 16C6.89333 16 5.85333 15.79 4.88 15.37C3.90667 14.95 3.06 14.38 2.34 13.66C1.62 12.94 1.05 12.0933 0.63 11.12C0.21 10.1467 0 9.10667 0 8C0 6.89333 0.21 5.85333 0.63 4.88C1.05 3.90667 1.62 3.06 2.34 2.34C3.06 1.62 3.90667 1.05 4.88 0.63C5.85333 0.21 6.89333 0 8 0C9.10667 0 10.1467 0.21 11.12 0.63C12.0933 1.05 12.94 1.62 13.66 2.34C14.38 3.06 14.95 3.90667 15.37 4.88C15.79 5.85333 16 6.89333 16 8C16 9.10667 15.79 10.1467 15.37 11.12C14.95 12.0933 14.38 12.94 13.66 13.66C12.94 14.38 12.0933 14.95 11.12 15.37C10.1467 15.79 9.10667 16 8 16Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "routeBreak"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 2.5H15.8333C16.7583 2.5 17.5 3.24167 17.5 4.16667V6.66667C17.5 7.58333 16.7583 8.33333 15.8333 8.33333H14.1667V10.8333C14.1667 10.9598 14.1596 11.0845 14.1459 11.2073C12.7497 11.6473 11.6473 12.7497 11.2073 14.1459C11.0845 14.1596 10.9598 14.1667 10.8333 14.1667H5.83333C3.99167 14.1667 2.5 12.675 2.5 10.8333V2.5ZM11.0122 15.8333H2.5V17.5H11.4678C11.2151 16.9915 11.0557 16.4285 11.0122 15.8333ZM14.1667 6.66667H15.8333V4.16667H14.1667V6.66667Z",
    fill: "currentColor"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.75C13.43 11.75 11.75 13.43 11.75 15.5C11.75 17.57 13.43 19.25 15.5 19.25C17.57 19.25 19.25 17.57 19.25 15.5C19.25 13.43 17.57 11.75 15.5 11.75ZM15.83 17.66V18.125H15.1737V17.6412C14.8963 17.5737 14.2775 17.3525 14.0412 16.5312L14.66 16.28C14.6825 16.3625 14.8775 17.0638 15.56 17.0638C15.9088 17.0638 16.3025 16.8837 16.3025 16.46C16.3025 16.1 16.04 15.9125 15.4475 15.6988C15.035 15.5525 14.1913 15.3125 14.1913 14.4575C14.1913 14.42 14.195 13.5575 15.1737 13.3475V12.875H15.83V13.34C16.52 13.46 16.7712 14.0113 16.8275 14.1762L16.235 14.4275C16.1937 14.2963 16.0138 13.925 15.5225 13.925C15.26 13.925 14.8438 14.0637 14.8438 14.4462C14.8438 14.8025 15.1663 14.9375 15.8338 15.1588C16.7338 15.47 16.9625 15.9275 16.9625 16.4525C16.9625 17.4388 16.025 17.6263 15.83 17.66Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "unpaidBreak"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.5H2.5V10.8333C2.5 12.675 3.99167 14.1667 5.83333 14.1667H10.8333C12.675 14.1667 14.1667 12.675 14.1667 10.8333V8.33333H15.8333C16.7583 8.33333 17.5 7.58333 17.5 6.66667V4.16667C17.5 3.24167 16.7583 2.5 15.8333 2.5ZM15.8333 6.66667H14.1667V4.16667H15.8333V6.66667ZM2.5 15.8333H15.8333V17.5H2.5V15.8333Z",
    fill: "#2FCC71"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "routeEnd"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1527 3.3335H5.41667C4.86667 3.3335 4.40833 3.6835 4.23333 4.17516L2.5 9.16683V15.8335C2.5 16.2918 2.875 16.6668 3.33333 16.6668H4.16667C4.625 16.6668 5 16.2918 5 15.8335V15.0002H15V15.8335C15 16.2918 15.375 16.6668 15.8333 16.6668H16.6667C17.125 16.6668 17.5 16.2918 17.5 15.8335V9.16683L17.3105 8.62098C16.7565 8.8647 16.144 9 15.5 9C14.6354 9 13.8277 8.75616 13.142 8.3335H4.16667L5.41667 4.5835H11.0008C11.0003 4.55572 11 4.52789 11 4.5C11 4.09656 11.0531 3.70553 11.1527 3.3335ZM4.16667 11.2502C4.16667 11.9418 4.725 12.5002 5.41667 12.5002C6.10833 12.5002 6.66667 11.9418 6.66667 11.2502C6.66667 10.5585 6.10833 10.0002 5.41667 10.0002C4.725 10.0002 4.16667 10.5585 4.16667 11.2502ZM13.3333 11.2502C13.3333 11.9418 13.8917 12.5002 14.5833 12.5002C15.275 12.5002 15.8333 11.9418 15.8333 11.2502C15.8333 10.5585 15.275 10.0002 14.5833 10.0002C13.8917 10.0002 13.3333 10.5585 13.3333 11.2502Z",
    fill: "currentColor"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.75C13.43 0.75 11.75 2.43 11.75 4.5C11.75 6.57 13.43 8.25 15.5 8.25C17.57 8.25 19.25 6.57 19.25 4.5C19.25 2.43 17.57 0.75 15.5 0.75ZM15.125 6H14.375V3H15.125V6ZM16.625 6H15.875V3H16.625V6Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "workTime"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 22.6667V8H24V12.3867C24.96 12.68 25.8667 13.1067 26.6667 13.68V8C26.6667 6.52 25.48 5.33333 24 5.33333H18.6667V2.66667C18.6667 1.18667 17.48 0 16 0H10.6667C9.18667 0 8 1.18667 8 2.66667V5.33333H2.66667C1.18667 5.33333 0.0133333 6.52 0.0133333 8L0 22.6667C0 24.1467 1.18667 25.3333 2.66667 25.3333H12.9067C12.5067 24.5067 12.24 23.6133 12.1067 22.6667H2.66667ZM10.6667 2.66667H16V5.33333H10.6667V2.66667Z",
    fill: "#2FCC71"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 14.6667C17.6533 14.6667 14.6667 17.6533 14.6667 21.3333C14.6667 25.0133 17.6533 28 21.3333 28C25.0133 28 28 25.0133 28 21.3333C28 17.6533 25.0133 14.6667 21.3333 14.6667ZM23.5333 24.4667L20.6667 21.6V17.3333H22V21.0533L24.4667 23.52L23.5333 24.4667Z",
    fill: "#2FCC71"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "workTimeGray"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 22.6667V8H24V12.3867C24.96 12.68 25.8667 13.1067 26.6667 13.68V8C26.6667 6.52 25.48 5.33333 24 5.33333H18.6667V2.66667C18.6667 1.18667 17.48 0 16 0H10.6667C9.18667 0 8 1.18667 8 2.66667V5.33333H2.66667C1.18667 5.33333 0.0133333 6.52 0.0133333 8L0 22.6667C0 24.1467 1.18667 25.3333 2.66667 25.3333H12.9067C12.5067 24.5067 12.24 23.6133 12.1067 22.6667H2.66667ZM10.6667 2.66667H16V5.33333H10.6667V2.66667Z",
    fill: "#8C8C8C"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 14.6667C17.6533 14.6667 14.6667 17.6533 14.6667 21.3333C14.6667 25.0133 17.6533 28 21.3333 28C25.0133 28 28 25.0133 28 21.3333C28 17.6533 25.0133 14.6667 21.3333 14.6667ZM23.5333 24.4667L20.6667 21.6V17.3333H22V21.0533L24.4667 23.52L23.5333 24.4667Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "car"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7667 1.17516C13.6 0.683496 13.1333 0.333496 12.5833 0.333496H3.41667C2.86667 0.333496 2.40833 0.683496 2.23333 1.17516L0.5 6.16683V12.8335C0.5 13.2918 0.875 13.6668 1.33333 13.6668H2.16667C2.625 13.6668 3 13.2918 3 12.8335V12.0002H13V12.8335C13 13.2918 13.375 13.6668 13.8333 13.6668H14.6667C15.125 13.6668 15.5 13.2918 15.5 12.8335V6.16683L13.7667 1.17516ZM3.41667 9.50016C2.725 9.50016 2.16667 8.94183 2.16667 8.25016C2.16667 7.5585 2.725 7.00016 3.41667 7.00016C4.10833 7.00016 4.66667 7.5585 4.66667 8.25016C4.66667 8.94183 4.10833 9.50016 3.41667 9.50016ZM12.5833 9.50016C11.8917 9.50016 11.3333 8.94183 11.3333 8.25016C11.3333 7.5585 11.8917 7.00016 12.5833 7.00016C13.275 7.00016 13.8333 7.5585 13.8333 8.25016C13.8333 8.94183 13.275 9.50016 12.5833 9.50016ZM2.16667 5.3335L3.41667 1.5835H12.5833L13.8333 5.3335H2.16667Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "car_stop_driving"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1527 3.3335H5.41667C4.86667 3.3335 4.40833 3.6835 4.23333 4.17516L2.5 9.16683V15.8335C2.5 16.2918 2.875 16.6668 3.33333 16.6668H4.16667C4.625 16.6668 5 16.2918 5 15.8335V15.0002H15V15.8335C15 16.2918 15.375 16.6668 15.8333 16.6668H16.6667C17.125 16.6668 17.5 16.2918 17.5 15.8335V9.16683L17.3105 8.62098C16.7565 8.8647 16.144 9 15.5 9C14.6354 9 13.8277 8.75616 13.142 8.3335H4.16667L5.41667 4.5835H11.0008C11.0003 4.55572 11 4.52789 11 4.5C11 4.09656 11.0531 3.70553 11.1527 3.3335ZM4.16667 11.2502C4.16667 11.9418 4.725 12.5002 5.41667 12.5002C6.10833 12.5002 6.66667 11.9418 6.66667 11.2502C6.66667 10.5585 6.10833 10.0002 5.41667 10.0002C4.725 10.0002 4.16667 10.5585 4.16667 11.2502ZM13.3333 11.2502C13.3333 11.9418 13.8917 12.5002 14.5833 12.5002C15.275 12.5002 15.8333 11.9418 15.8333 11.2502C15.8333 10.5585 15.275 10.0002 14.5833 10.0002C13.8917 10.0002 13.3333 10.5585 13.3333 11.2502Z",
    fill: "#8C8C8C"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.75C13.43 0.75 11.75 2.43 11.75 4.5C11.75 6.57 13.43 8.25 15.5 8.25C17.57 8.25 19.25 6.57 19.25 4.5C19.25 2.43 17.57 0.75 15.5 0.75ZM15.125 6H14.375V3H15.125V6ZM16.625 6H15.875V3H16.625V6Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7501 12.9165L12.9167 11.7498L9.83342 8.6665V4.83317H8.16675V9.33317L11.7501 12.9165ZM9.00008 17.3332C7.8473 17.3332 6.76397 17.1144 5.75008 16.6769C4.73619 16.2394 3.85425 15.6457 3.10425 14.8957C2.35425 14.1457 1.7605 13.2637 1.323 12.2498C0.885498 11.2359 0.666748 10.1526 0.666748 8.99984C0.666748 7.84706 0.885498 6.76373 1.323 5.74984C1.7605 4.73595 2.35425 3.854 3.10425 3.104C3.85425 2.354 4.73619 1.76025 5.75008 1.32275C6.76397 0.885254 7.8473 0.666504 9.00008 0.666504C10.1529 0.666504 11.2362 0.885254 12.2501 1.32275C13.264 1.76025 14.1459 2.354 14.8959 3.104C15.6459 3.854 16.2397 4.73595 16.6772 5.74984C17.1147 6.76373 17.3334 7.84706 17.3334 8.99984C17.3334 10.1526 17.1147 11.2359 16.6772 12.2498C16.2397 13.2637 15.6459 14.1457 14.8959 14.8957C14.1459 15.6457 13.264 16.2394 12.2501 16.6769C11.2362 17.1144 10.1529 17.3332 9.00008 17.3332Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "clock_stop"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1323 8.15021C17.3921 8.6849 16.4829 9 15.5 9C13.0147 9 11 6.98528 11 4.5C11 3.51704 11.3152 2.6077 11.8499 1.8675C11.2545 1.7335 10.6378 1.6665 9.99984 1.6665C8.84706 1.6665 7.76373 1.88525 6.74984 2.32275C5.73595 2.76025 4.854 3.354 4.104 4.104C3.354 4.854 2.76025 5.73595 2.32275 6.74984C1.88525 7.76373 1.6665 8.84706 1.6665 9.99984C1.6665 11.1526 1.88525 12.2359 2.32275 13.2498C2.76025 14.2637 3.354 15.1457 4.104 15.8957C4.854 16.6457 5.73595 17.2394 6.74984 17.6769C7.76373 18.1144 8.84706 18.3332 9.99984 18.3332C11.1526 18.3332 12.2359 18.1144 13.2498 17.6769C14.2637 17.2394 15.1457 16.6457 15.8957 15.8957C16.6457 15.1457 17.2394 14.2637 17.6769 13.2498C18.1144 12.2359 18.3332 11.1526 18.3332 9.99984C18.3332 9.36204 18.2662 8.7455 18.1323 8.15021ZM13.9165 12.7498L12.7498 13.9165L9.1665 10.3332V5.83317H10.8332V9.6665L13.9165 12.7498Z",
    fill: "#8C8C8C"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.75C13.43 0.75 11.75 2.43 11.75 4.5C11.75 6.57 13.43 8.25 15.5 8.25C17.57 8.25 19.25 6.57 19.25 4.5C19.25 2.43 17.57 0.75 15.5 0.75ZM15.125 6H14.375V3H15.125V6ZM16.625 6H15.875V3H16.625V6Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "car_start_shift"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5833 3.3335C15.1333 3.3335 15.6 3.6835 15.7667 4.17516L17.5 9.16683V11.4678C16.985 11.2119 16.4141 11.0517 15.8105 11.0105C15.6991 10.434 15.193 10.0002 14.5833 10.0002C13.8917 10.0002 13.3333 10.5585 13.3333 11.2502C13.3333 11.3489 13.3447 11.445 13.3662 11.5371C12.0963 12.2223 11.1932 13.5001 11.0274 15.0002H5V15.8335C5 16.2918 4.625 16.6668 4.16667 16.6668H3.33333C2.875 16.6668 2.5 16.2918 2.5 15.8335V9.16683L4.23333 4.17516C4.40833 3.6835 4.86667 3.3335 5.41667 3.3335H14.5833ZM4.16667 11.2502C4.16667 11.9418 4.725 12.5002 5.41667 12.5002C6.10833 12.5002 6.66667 11.9418 6.66667 11.2502C6.66667 10.5585 6.10833 10.0002 5.41667 10.0002C4.725 10.0002 4.16667 10.5585 4.16667 11.2502ZM5.41667 4.5835L4.16667 8.3335H15.8333L14.5833 4.5835H5.41667Z",
    fill: "#8C8C8C"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7375 17.2625L17.2625 16.7375L15.875 15.35V13.625H15.125V15.65L16.7375 17.2625ZM15.5 19.25C14.9813 19.25 14.4938 19.1516 14.0375 18.9547C13.5812 18.7578 13.1844 18.4906 12.8469 18.1531C12.5094 17.8156 12.2422 17.4188 12.0453 16.9625C11.8484 16.5063 11.75 16.0188 11.75 15.5C11.75 14.9813 11.8484 14.4938 12.0453 14.0375C12.2422 13.5812 12.5094 13.1844 12.8469 12.8469C13.1844 12.5094 13.5812 12.2422 14.0375 12.0453C14.4938 11.8484 14.9813 11.75 15.5 11.75C16.0188 11.75 16.5063 11.8484 16.9625 12.0453C17.4188 12.2422 17.8156 12.5094 18.1531 12.8469C18.4906 13.1844 18.7578 13.5812 18.9547 14.0375C19.1516 14.4938 19.25 14.9813 19.25 15.5C19.25 16.0188 19.1516 16.5063 18.9547 16.9625C18.7578 17.4188 18.4906 17.8156 18.1531 18.1531C17.8156 18.4906 17.4188 18.7578 16.9625 18.9547C16.5063 19.1516 16.0188 19.25 15.5 19.25Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "car_stop_shift"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3105 8.62098L17.5 9.16683V11.4678C16.985 11.2119 16.4141 11.0517 15.8105 11.0105C15.6991 10.434 15.193 10.0002 14.5833 10.0002C13.8917 10.0002 13.3333 10.5585 13.3333 11.2502C13.3333 11.3489 13.3447 11.445 13.3662 11.5371C12.0963 12.2223 11.1932 13.5001 11.0274 15.0002H5V15.8335C5 16.2918 4.625 16.6668 4.16667 16.6668H3.33333C2.875 16.6668 2.5 16.2918 2.5 15.8335V9.16683L4.23333 4.17516C4.40833 3.6835 4.86667 3.3335 5.41667 3.3335H11.1527C11.0531 3.70553 11 4.09656 11 4.5C11 4.52789 11.0003 4.55572 11.0008 4.5835H5.41667L4.16667 8.3335H13.142C13.8277 8.75616 14.6354 9 15.5 9C16.144 9 16.7565 8.8647 17.3105 8.62098ZM5.41667 12.5002C4.725 12.5002 4.16667 11.9418 4.16667 11.2502C4.16667 10.5585 4.725 10.0002 5.41667 10.0002C6.10833 10.0002 6.66667 10.5585 6.66667 11.2502C6.66667 11.9418 6.10833 12.5002 5.41667 12.5002Z",
    fill: "#8C8C8C"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7375 17.2625L17.2625 16.7375L15.875 15.35V13.625H15.125V15.65L16.7375 17.2625ZM15.5 19.25C14.9813 19.25 14.4938 19.1516 14.0375 18.9547C13.5812 18.7578 13.1844 18.4906 12.8469 18.1531C12.5094 17.8156 12.2422 17.4188 12.0453 16.9625C11.8484 16.5063 11.75 16.0188 11.75 15.5C11.75 14.9813 11.8484 14.4938 12.0453 14.0375C12.2422 13.5812 12.5094 13.1844 12.8469 12.8469C13.1844 12.5094 13.5812 12.2422 14.0375 12.0453C14.4938 11.8484 14.9813 11.75 15.5 11.75C16.0188 11.75 16.5063 11.8484 16.9625 12.0453C17.4188 12.2422 17.8156 12.5094 18.1531 12.8469C18.4906 13.1844 18.7578 13.5812 18.9547 14.0375C19.1516 14.4938 19.25 14.9813 19.25 15.5C19.25 16.0188 19.1516 16.5063 18.9547 16.9625C18.7578 17.4188 18.4906 17.8156 18.1531 18.1531C17.8156 18.4906 17.4188 18.7578 16.9625 18.9547C16.5063 19.1516 16.0188 19.25 15.5 19.25Z",
    fill: "#8C8C8C"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.75C13.43 0.75 11.75 2.43 11.75 4.5C11.75 6.57 13.43 8.25 15.5 8.25C17.57 8.25 19.25 6.57 19.25 4.5C19.25 2.43 17.57 0.75 15.5 0.75ZM15.125 6H14.375V3H15.125V6ZM16.625 6H15.875V3H16.625V6Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "break"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.5H2.5V10.8333C2.5 12.675 3.99167 14.1667 5.83333 14.1667H10.8333C12.675 14.1667 14.1667 12.675 14.1667 10.8333V8.33333H15.8333C16.7583 8.33333 17.5 7.58333 17.5 6.66667V4.16667C17.5 3.24167 16.7583 2.5 15.8333 2.5ZM15.8333 6.66667H14.1667V4.16667H15.8333V6.66667ZM2.5 15.8333H15.8333V17.5H2.5V15.8333Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "break_paid"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 2.5H15.8333C16.7583 2.5 17.5 3.24167 17.5 4.16667V6.66667C17.5 7.58333 16.7583 8.33333 15.8333 8.33333H14.1667V10.8333C14.1667 10.9598 14.1596 11.0845 14.1459 11.2073C12.7497 11.6473 11.6473 12.7497 11.2073 14.1459C11.0845 14.1596 10.9598 14.1667 10.8333 14.1667H5.83333C3.99167 14.1667 2.5 12.675 2.5 10.8333V2.5ZM11.0122 15.8333H2.5V17.5H11.4678C11.2151 16.9915 11.0557 16.4285 11.0122 15.8333ZM14.1667 6.66667H15.8333V4.16667H14.1667V6.66667Z",
    fill: "#8C8C8C"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.75C13.43 11.75 11.75 13.43 11.75 15.5C11.75 17.57 13.43 19.25 15.5 19.25C17.57 19.25 19.25 17.57 19.25 15.5C19.25 13.43 17.57 11.75 15.5 11.75ZM15.83 17.66V18.125H15.1737V17.6412C14.8963 17.5737 14.2775 17.3525 14.0412 16.5312L14.66 16.28C14.6825 16.3625 14.8775 17.0638 15.56 17.0638C15.9088 17.0638 16.3025 16.8837 16.3025 16.46C16.3025 16.1 16.04 15.9125 15.4475 15.6988C15.035 15.5525 14.1913 15.3125 14.1913 14.4575C14.1913 14.42 14.195 13.5575 15.1737 13.3475V12.875H15.83V13.34C16.52 13.46 16.7712 14.0113 16.8275 14.1762L16.235 14.4275C16.1937 14.2963 16.0138 13.925 15.5225 13.925C15.26 13.925 14.8438 14.0637 14.8438 14.4462C14.8438 14.8025 15.1663 14.9375 15.8338 15.1588C16.7338 15.47 16.9625 15.9275 16.9625 16.4525C16.9625 17.4388 16.025 17.6263 15.83 17.66Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "expand_more"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7512 5.87561L8.5 9.11978L5.24875 5.87561L4.25 6.87436L8.5 11.1244L12.75 6.87436L11.7512 5.87561Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "slider_add"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0037 8H8.00366V14H6.00366V8H0.00366211V6H6.00366V0H8.00366V6H14.0037V8Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "slider_remove"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 2,
    viewBox: "0 0 14 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0037 2H0.00366211V0H14.0037V2Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_photo_library"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.33341V13.3334H6.66669V3.33341H16.6667ZM16.6667 1.66675H6.66669C5.75002 1.66675 5.00002 2.41675 5.00002 3.33341V13.3334C5.00002 14.2501 5.75002 15.0001 6.66669 15.0001H16.6667C17.5834 15.0001 18.3334 14.2501 18.3334 13.3334V3.33341C18.3334 2.41675 17.5834 1.66675 16.6667 1.66675ZM9.58335 9.72508L10.9917 11.6084L13.0584 9.02508L15.8334 12.5001H7.50002L9.58335 9.72508ZM1.66669 5.00008V16.6667C1.66669 17.5834 2.41669 18.3334 3.33335 18.3334H15V16.6667H3.33335V5.00008H1.66669Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_schedule"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99169 1.66675C5.39169 1.66675 1.66669 5.40008 1.66669 10.0001C1.66669 14.6001 5.39169 18.3334 9.99169 18.3334C14.6 18.3334 18.3334 14.6001 18.3334 10.0001C18.3334 5.40008 14.6 1.66675 9.99169 1.66675ZM10 16.6667C6.31669 16.6667 3.33335 13.6834 3.33335 10.0001C3.33335 6.31675 6.31669 3.33341 10 3.33341C13.6834 3.33341 16.6667 6.31675 16.6667 10.0001C16.6667 13.6834 13.6834 16.6667 10 16.6667ZM10.4167 5.83342H9.16669V10.8334L13.5417 13.4584L14.1667 12.4334L10.4167 10.2084V5.83342Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_supervisor_account"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 10.0001C9.10835 10.0001 10.4167 8.69175 10.4167 7.08341C10.4167 5.47508 9.10835 4.16675 7.50002 4.16675C5.89169 4.16675 4.58335 5.47508 4.58335 7.08341C4.58335 8.69175 5.89169 10.0001 7.50002 10.0001ZM7.50002 5.83341C8.19169 5.83341 8.75002 6.39175 8.75002 7.08341C8.75002 7.77508 8.19169 8.33341 7.50002 8.33341C6.80835 8.33341 6.25002 7.77508 6.25002 7.08341C6.25002 6.39175 6.80835 5.83341 7.50002 5.83341ZM7.54169 14.1667H3.97502C4.80002 13.7501 6.22502 13.3334 7.50002 13.3334C7.59169 13.3334 7.69169 13.3417 7.78335 13.3417C8.06669 12.7334 8.55835 12.2334 9.15002 11.8334C8.54169 11.7251 7.96669 11.6667 7.50002 11.6667C5.55002 11.6667 1.66669 12.6417 1.66669 14.5834V15.8334H7.50002V14.5834C7.50002 14.4417 7.51669 14.3001 7.54169 14.1667ZM13.75 12.0834C12.2167 12.0834 9.16669 12.9251 9.16669 14.5834V15.8334H18.3334V14.5834C18.3334 12.9251 15.2834 12.0834 13.75 12.0834ZM14.7584 10.5667C15.3917 10.2084 15.8334 9.53341 15.8334 8.75008C15.8334 7.60008 14.9 6.66675 13.75 6.66675C12.6 6.66675 11.6667 7.60008 11.6667 8.75008C11.6667 9.53341 12.1084 10.2084 12.7417 10.5667C13.0417 10.7334 13.3834 10.8334 13.75 10.8334C14.1167 10.8334 14.4584 10.7334 14.7584 10.5667Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_pin_drop"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33341C11.6084 3.33341 14.1667 4.50008 14.1667 7.62508C14.1667 9.42508 12.7334 11.5167 10 13.7251C7.26669 11.5167 5.83335 9.41675 5.83335 7.62508C5.83335 4.50008 8.39169 3.33341 10 3.33341ZM10 1.66675C7.27502 1.66675 4.16669 3.71675 4.16669 7.62508C4.16669 10.2251 6.10835 12.9667 10 15.8334C13.8917 12.9667 15.8334 10.2251 15.8334 7.62508C15.8334 3.71675 12.725 1.66675 10 1.66675Z",
    fill: "currentColor"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.83342C9.08335 5.83342 8.33335 6.58342 8.33335 7.50008C8.33335 8.41675 9.08335 9.16675 10 9.16675C10.442 9.16675 10.866 8.99115 11.1785 8.67859C11.4911 8.36603 11.6667 7.94211 11.6667 7.50008C11.6667 7.05805 11.4911 6.63413 11.1785 6.32157C10.866 6.00901 10.442 5.83342 10 5.83342ZM4.16669 16.6667H15.8334V18.3334H4.16669V16.6667Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_delete"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 7.5V15.8333H6.66669V7.5H13.3334ZM12.0834 2.5H7.91669L7.08335 3.33333H4.16669V5H15.8334V3.33333H12.9167L12.0834 2.5ZM15 5.83333H5.00002V15.8333C5.00002 16.75 5.75002 17.5 6.66669 17.5H13.3334C14.25 17.5 15 16.75 15 15.8333V5.83333Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_arrow_drop_down"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95831 7.22925L8.49998 10.7709L12.0416 7.22925H4.95831Z",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_star"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49999 13.087L12.8775 15.7291L11.7158 10.7495L15.5833 7.39909L10.4904 6.967L8.49999 2.27075L6.50957 6.967L1.41666 7.39909L5.28416 10.7495L4.12249 15.7291L8.49999 13.087Z",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_checkbox"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E74C3B"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 12.6666H7.33331V11.3333H16.6666V12.6666Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_star_yellow"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.6933L24.24 28.6666L22.0533 19.2933L29.3333 12.9866L19.7467 12.1733L16 3.33325L12.2533 12.1733L2.66666 12.9866L9.94666 19.2933L7.75999 28.6666L16 23.6933Z",
    fill: "#F1C50D"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_sell"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5442 15.2166L16.7709 3.44326C16.2775 2.94992 15.5975 2.66992 14.8909 2.66992H5.33085C3.86418 2.66992 2.66418 3.86992 2.66418 5.33659V14.8966C2.66418 15.6033 2.94418 16.2833 3.45085 16.7766L15.2242 28.5499C16.2642 29.5899 17.9575 29.5899 18.9975 28.5499L28.5575 18.9899C29.5975 17.9499 29.5975 16.2699 28.5442 15.2166ZM17.1042 26.6699L5.33085 14.8966V5.33659H14.8909L26.6642 17.1099L17.1042 26.6699Z",
    fill: "currentColor"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66418 10.6699C9.76875 10.6699 10.6642 9.77449 10.6642 8.66992C10.6642 7.56535 9.76875 6.66992 8.66418 6.66992C7.55961 6.66992 6.66418 7.56535 6.66418 8.66992C6.66418 9.77449 7.55961 10.6699 8.66418 10.6699Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_info"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.33342H17.3334V12.0001H14.6667V9.33342ZM14.6667 14.6667H17.3334V22.6667H14.6667V14.6667ZM16 2.66675C8.64002 2.66675 2.66669 8.64008 2.66669 16.0001C2.66669 23.3601 8.64002 29.3334 16 29.3334C23.36 29.3334 29.3334 23.3601 29.3334 16.0001C29.3334 8.64008 23.36 2.66675 16 2.66675ZM16 26.6667C10.12 26.6667 5.33335 21.8801 5.33335 16.0001C5.33335 10.1201 10.12 5.33341 16 5.33341C21.88 5.33341 26.6667 10.1201 26.6667 16.0001C26.6667 21.8801 21.88 26.6667 16 26.6667Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 9.33325H17.3334V11.9999H22.6667C24.8667 11.9999 26.6667 13.7999 26.6667 15.9999C26.6667 18.1999 24.8667 19.9999 22.6667 19.9999H17.3334V22.6666H22.6667C26.3467 22.6666 29.3334 19.6799 29.3334 15.9999C29.3334 12.3199 26.3467 9.33325 22.6667 9.33325ZM14.6667 19.9999H9.33335C7.13335 19.9999 5.33335 18.1999 5.33335 15.9999C5.33335 13.7999 7.13335 11.9999 9.33335 11.9999H14.6667V9.33325H9.33335C5.65335 9.33325 2.66669 12.3199 2.66669 15.9999C2.66669 19.6799 5.65335 22.6666 9.33335 22.6666H14.6667V19.9999ZM10.6667 14.6666H21.3334V17.3333H10.6667V14.6666Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_download"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 12.6667H20V4.66675H12V12.6667H6.66669L16 22.0001L25.3334 12.6667ZM14.6667 15.3334V7.33341H17.3334V15.3334H18.8934L16 18.2267L13.1067 15.3334H14.6667ZM6.66669 24.6667H25.3334V27.3334H6.66669V24.6667Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_delete_outline"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 25.3333C8.00002 26.8 9.20002 28 10.6667 28H21.3334C22.8 28 24 26.8 24 25.3333V9.33333H8.00002V25.3333ZM10.6667 12H21.3334V25.3333H10.6667V12ZM20.6667 5.33333L19.3334 4H12.6667L11.3334 5.33333H6.66669V8H25.3334V5.33333H20.6667Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "file_start_rating"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 12.587L12.8775 15.2291L11.7159 10.2495L15.5834 6.89909L10.4904 6.467L8.50002 1.77075L6.5096 6.467L1.41669 6.89909L5.28419 10.2495L4.12252 15.2291L8.50002 12.587Z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "keyboard_arrow_left"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7809 12.4557L8.34554 9.01355L11.7802 5.57071L10.7225 4.51332L6.22304 9.01376L10.7235 13.5133L11.7809 12.4557Z",
    fill: "#8C8C8C"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrowback"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 9.65007H5.37045L12.917 2.10357L11 0.200073L0.199951 11.0001L11 21.8001L12.9035 19.8966L5.37045 12.3501H21.8V9.65007Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron_left"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9286 37.9423L25.5091 27.5001L35.9286 17.0578L32.7208 13.8501L19.0708 27.5001L32.7208 41.1501L35.9286 37.9423Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron_right"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M22.279 13.8501L19.0713 17.0578L29.4908 27.5001L19.0713 37.9423L22.279 41.1501L35.929 27.5001L22.279 13.8501Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "start_empty"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6061 14.7578L22.7121 13.8184L18.4545 3.78809L14.197 13.8335L3.30302 14.7578L11.5758 21.9244L9.0909 32.576L18.4545 26.9244L27.8182 32.576L25.3485 21.9244L33.6061 14.7578ZM18.4545 24.0911L12.7576 27.5305L14.2727 21.0457L9.24242 16.682L15.8788 16.1063L18.4545 10.0002L21.0454 16.1214L27.6818 16.6972L22.6515 21.0608L24.1667 27.5457L18.4545 24.0911Z",
    fill: "#F1C50D"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "start_fill"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1818 26.9244L27.5455 32.576L25.0606 21.9244L33.3333 14.7578L22.4394 13.8335L18.1818 3.78809L13.9242 13.8335L3.0303 14.7578L11.303 21.9244L8.81818 32.576L18.1818 26.9244Z",
    fill: "#F1C50D"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "photo_size_select_actual"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 2.5H2.50016C1.66683 2.5 0.833496 3.33333 0.833496 4.16667V15.8333C0.833496 16.75 1.5835 17.5 2.50016 17.5H17.5002C18.3335 17.5 19.1668 16.6667 19.1668 15.8333V4.16667C19.1668 3.33333 18.3335 2.5 17.5002 2.5ZM17.5002 15.7667C17.4835 15.7917 17.4502 15.8167 17.4335 15.8333H2.50016V4.23333L2.56683 4.16667H17.4252C17.4502 4.18333 17.4752 4.21667 17.4918 4.23333V15.7667H17.5002ZM9.16683 12.925L7.0835 10.4167L4.16683 14.1667H15.8335L12.0835 9.16667L9.16683 12.925Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "account_circle"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66663C5.39984 1.66663 1.6665 5.39996 1.6665 9.99996C1.6665 14.6 5.39984 18.3333 9.99984 18.3333C14.5998 18.3333 18.3332 14.6 18.3332 9.99996C18.3332 5.39996 14.5998 1.66663 9.99984 1.66663ZM5.8915 15.2333C6.24984 14.4833 8.43317 13.75 9.99984 13.75C11.5665 13.75 13.7582 14.4833 14.1082 15.2333C12.9748 16.1333 11.5498 16.6666 9.99984 16.6666C8.44984 16.6666 7.02484 16.1333 5.8915 15.2333ZM15.2998 14.025C14.1082 12.575 11.2165 12.0833 9.99984 12.0833C8.78317 12.0833 5.8915 12.575 4.69984 14.025C3.84984 12.9083 3.33317 11.5166 3.33317 9.99996C3.33317 6.32496 6.32484 3.33329 9.99984 3.33329C13.6748 3.33329 16.6665 6.32496 16.6665 9.99996C16.6665 11.5166 16.1498 12.9083 15.2998 14.025ZM9.99984 4.99996C8.38317 4.99996 7.08317 6.29996 7.08317 7.91663C7.08317 9.53329 8.38317 10.8333 9.99984 10.8333C11.6165 10.8333 12.9165 9.53329 12.9165 7.91663C12.9165 6.29996 11.6165 4.99996 9.99984 4.99996ZM9.99984 9.16663C9.30817 9.16663 8.74984 8.60829 8.74984 7.91663C8.74984 7.22496 9.30817 6.66663 9.99984 6.66663C10.6915 6.66663 11.2498 7.22496 11.2498 7.91663C11.2498 8.60829 10.6915 9.16663 9.99984 9.16663Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "location_on"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66663C6.77484 1.66663 4.1665 4.27496 4.1665 7.49996C4.1665 11.875 9.99984 18.3333 9.99984 18.3333C9.99984 18.3333 15.8332 11.875 15.8332 7.49996C15.8332 4.27496 13.2248 1.66663 9.99984 1.66663ZM5.83317 7.49996C5.83317 5.19996 7.69984 3.33329 9.99984 3.33329C12.2998 3.33329 14.1665 5.19996 14.1665 7.49996C14.1665 9.89996 11.7665 13.4916 9.99984 15.7333C8.2665 13.5083 5.83317 9.87496 5.83317 7.49996Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 9.58329C11.1504 9.58329 12.0832 8.65055 12.0832 7.49996C12.0832 6.34937 11.1504 5.41663 9.99984 5.41663C8.84924 5.41663 7.9165 6.34937 7.9165 7.49996C7.9165 8.65055 8.84924 9.58329 9.99984 9.58329Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar_today"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 2.50004H15.8332V0.833374H14.1665V2.50004H5.83317V0.833374H4.1665V2.50004H3.33317C2.4165 2.50004 1.6665 3.25004 1.6665 4.16671V17.5C1.6665 18.4167 2.4165 19.1667 3.33317 19.1667H16.6665C17.5832 19.1667 18.3332 18.4167 18.3332 17.5V4.16671C18.3332 3.25004 17.5832 2.50004 16.6665 2.50004ZM16.6665 17.5H3.33317V8.33337H16.6665V17.5ZM16.6665 6.66671H3.33317V4.16671H16.6665V6.66671Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "missed_punch"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20962_24676)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.82418 4.86954L1.75 5.08317V8.4165C1.75 8.64567 1.9375 8.83317 2.16667 8.83317H2.58333C2.8125 8.83317 3 8.64567 3 8.4165V7.99984H8V8.4165C8 8.64567 8.1875 8.83317 8.41667 8.83317H8.83333C9.0625 8.83317 9.25 8.64567 9.25 8.4165V5.08317L8.38333 2.58734C8.3 2.3415 8.06667 2.1665 7.79167 2.1665H4.99707C5.05326 2.36518 5.08333 2.57483 5.08333 2.7915C5.08333 2.86173 5.08017 2.93122 5.07399 2.99984H7.64167L8.09167 4.29567H4.52065C4.10051 4.77819 3.48171 5.08317 2.79167 5.08317C2.44595 5.08317 2.11811 5.00662 1.82418 4.86954ZM2.79167 5.08317H2.58333V7.1665H8.41667V5.08317H2.79167ZM3.625 6.74984C3.97018 6.74984 4.25 6.47002 4.25 6.12484C4.25 5.77966 3.97018 5.49984 3.625 5.49984C3.27982 5.49984 3 5.77966 3 6.12484C3 6.47002 3.27982 6.74984 3.625 6.74984ZM8 6.12484C8 6.47002 7.72018 6.74984 7.375 6.74984C7.02982 6.74984 6.75 6.47002 6.75 6.12484C6.75 5.77966 7.02982 5.49984 7.375 5.49984C7.72018 5.49984 8 5.77966 8 6.12484Z",
    fill: "#8B2E23"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_20962_24676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.46338 3.11963C2.38005 3.0363 2.30387 2.94906 2.23486 2.85791C2.16585 2.76676 2.1027 2.67041 2.04541 2.56885C2.03239 2.60531 2.02393 2.64242 2.02002 2.68018C2.01611 2.71794 2.01416 2.75505 2.01416 2.7915C2.01416 3.00765 2.08968 3.19124 2.24072 3.34229C2.39176 3.49333 2.57536 3.56885 2.7915 3.56885C2.82796 3.56885 2.86507 3.56624 2.90283 3.56104C2.94059 3.55583 2.9777 3.54801 3.01416 3.5376C2.9126 3.48031 2.81624 3.41716 2.7251 3.34814C2.63395 3.27913 2.54671 3.20296 2.46338 3.11963ZM2.68604 2.90088C2.81885 3.03369 2.96729 3.14762 3.13135 3.24268C3.29541 3.33773 3.47119 3.4113 3.65869 3.46338C3.55452 3.59619 3.42692 3.69971 3.27588 3.77393C3.12484 3.84814 2.96468 3.88525 2.79541 3.88525C2.49072 3.88525 2.23226 3.77913 2.02002 3.56689C1.80778 3.35466 1.70166 3.09619 1.70166 2.7915C1.70166 2.62223 1.73877 2.46208 1.81299 2.31104C1.88721 2.15999 1.99072 2.03239 2.12354 1.92822C2.17562 2.11572 2.24919 2.2915 2.34424 2.45557C2.43929 2.61963 2.55322 2.76807 2.68604 2.90088ZM3.81885 3.18213C3.76676 3.16911 3.71533 3.15479 3.66455 3.13916C3.61377 3.12354 3.56364 3.10531 3.51416 3.08447C3.53499 3.0376 3.54997 2.99007 3.55908 2.94189C3.5682 2.89372 3.57275 2.84359 3.57275 2.7915C3.57275 2.57536 3.49658 2.39111 3.34424 2.23877C3.19189 2.08643 3.00765 2.01025 2.7915 2.01025C2.73942 2.01025 2.68929 2.01481 2.64111 2.02393C2.59294 2.03304 2.54541 2.04801 2.49854 2.06885C2.4777 2.01937 2.46012 1.96989 2.4458 1.92041C2.43148 1.87093 2.41781 1.82015 2.40479 1.76807C2.46729 1.74463 2.53109 1.72705 2.59619 1.71533C2.6613 1.70361 2.7277 1.69775 2.79541 1.69775C3.1001 1.69775 3.35856 1.80387 3.5708 2.01611C3.78304 2.22835 3.88916 2.48682 3.88916 2.7915C3.88916 2.85921 3.8833 2.92562 3.87158 2.99072C3.85986 3.05583 3.84229 3.11963 3.81885 3.18213ZM2.63525 1.38525V0.916504H2.94775V1.38525H2.63525ZM2.63525 4.6665V4.19775H2.94775V4.6665H2.63525ZM3.89697 1.90869L3.67432 1.68604L4.00635 1.35791L4.229 1.57666L3.89697 1.90869ZM1.57666 4.2251L1.354 4.00635L1.68604 3.67432L1.90869 3.89697L1.57666 4.2251ZM4.19775 2.94775V2.63525H4.6665V2.94775H4.19775ZM0.916504 2.94775V2.63525H1.38525V2.94775H0.916504ZM4.00635 4.229L3.67432 3.89697L3.89697 3.67432L4.2251 4.00635L4.00635 4.229ZM1.68604 1.90869L1.35791 1.57666L1.57666 1.354L1.90869 1.68604L1.68604 1.90869Z",
    fill: "#8B2E23"
  })))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 7.5,
    r: 3,
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49984 4.1665C7.65984 4.1665 6.1665 5.65984 6.1665 7.49984C6.1665 9.33984 7.65984 10.8332 9.49984 10.8332C11.3398 10.8332 12.8332 9.33984 12.8332 7.49984C12.8332 5.65984 11.3398 4.1665 9.49984 4.1665ZM9.83317 9.1665H9.1665V8.49984H9.83317V9.1665ZM9.83317 7.83317H9.1665V5.83317H9.83317V7.83317Z",
    fill: "#8B2E23"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20962_24676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_20962_24676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.75,
    height: 3.75,
    fill: "white",
    transform: "translate(0.916504 0.916504)"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "route-icon"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 9.4875V4.375C11.875 2.99375 10.7563 1.875 9.375 1.875C7.99375 1.875 6.875 2.99375 6.875 4.375V10.625C6.875 11.3125 6.3125 11.875 5.625 11.875C4.9375 11.875 4.375 11.3125 4.375 10.625V5.5125C5.1 5.25 5.625 4.5625 5.625 3.75C5.625 2.7125 4.7875 1.875 3.75 1.875C2.7125 1.875 1.875 2.7125 1.875 3.75C1.875 4.5625 2.4 5.25 3.125 5.5125V10.625C3.125 12.0063 4.24375 13.125 5.625 13.125C7.00625 13.125 8.125 12.0063 8.125 10.625V4.375C8.125 3.6875 8.6875 3.125 9.375 3.125C10.0625 3.125 10.625 3.6875 10.625 4.375V9.4875C9.9 9.74375 9.375 10.4312 9.375 11.25C9.375 12.2875 10.2125 13.125 11.25 13.125C12.2875 13.125 13.125 12.2875 13.125 11.25C13.125 10.4375 12.6 9.75 11.875 9.4875ZM3.75 4.375C3.40625 4.375 3.125 4.09375 3.125 3.75C3.125 3.40625 3.40625 3.125 3.75 3.125C4.09375 3.125 4.375 3.40625 4.375 3.75C4.375 4.09375 4.09375 4.375 3.75 4.375ZM11.25 11.875C10.9062 11.875 10.625 11.5938 10.625 11.25C10.625 10.9062 10.9062 10.625 11.25 10.625C11.5938 10.625 11.875 10.9062 11.875 11.25C11.875 11.5938 11.5938 11.875 11.25 11.875Z",
    fill: "#EC7062"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "time-icon"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49375 0.25C3.04375 0.25 0.25 3.05 0.25 6.5C0.25 9.95 3.04375 12.75 6.49375 12.75C9.95 12.75 12.75 9.95 12.75 6.5C12.75 3.05 9.95 0.25 6.49375 0.25ZM6.5 11.5C3.7375 11.5 1.5 9.2625 1.5 6.5C1.5 3.7375 3.7375 1.5 6.5 1.5C9.2625 1.5 11.5 3.7375 11.5 6.5C11.5 9.2625 9.2625 11.5 6.5 11.5ZM6.8125 3.375H5.875V7.125L9.15625 9.09375L9.625 8.325L6.8125 6.65625V3.375Z",
    fill: "#EC7062"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.61139c259851a714e4cc561ace0a9c97.svg";
export { ForwardRef as ReactComponent };